var items = {
  "block.minecraft.acacia_button": "Акация түйме",
  "block.minecraft.acacia_door": "Акация есік",
  "block.minecraft.acacia_fence": "Акация шарбақ",
  "block.minecraft.acacia_fence_gate": "Акация қақпа",
  "block.minecraft.acacia_hanging_sign": "Аспалы акация маңдайша",
  "block.minecraft.acacia_leaves": "Акация жапырағы",
  "block.minecraft.acacia_log": "Акация діңгегі",
  "block.minecraft.acacia_planks": "Акация тақтай",
  "block.minecraft.acacia_pressure_plate": "Акация басқыш",
  "block.minecraft.acacia_sapling": "Акация көшеті",
  "block.minecraft.acacia_shelf": "Акация сөре",
  "block.minecraft.acacia_sign": "Акация маңдайша",
  "block.minecraft.acacia_slab": "Акация тақта",
  "block.minecraft.acacia_stairs": "Акация тепкішек",
  "block.minecraft.acacia_trapdoor": "Акация қақпақ",
  "block.minecraft.acacia_wall_hanging_sign": "Дуалдағы аспалы акация маңдайша",
  "block.minecraft.acacia_wall_sign": "Дуалдағы акация маңдайша",
  "block.minecraft.acacia_wood": "Акация ағашы",
  "block.minecraft.activator_rail": "Белсендіргіш теміржол",
  "block.minecraft.air": "Ауа",
  "block.minecraft.allium": "Жуа",
  "block.minecraft.amethyst_block": "Аметист блок",
  "block.minecraft.amethyst_cluster": "Аметист кластері",
  "block.minecraft.ancient_debris": "Ежелгі қалдық",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезит тақта",
  "block.minecraft.andesite_stairs": "Андезит тепкішек",
  "block.minecraft.andesite_wall": "Андезит дуал",
  "block.minecraft.anvil": "Төс",
  "block.minecraft.attached_melon_stem": "Жабысқан қарбыз сабағы",
  "block.minecraft.attached_pumpkin_stem": "Жабысқан асқабақ сабағы",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Азалия жапырағы",
  "block.minecraft.azure_bluet": "Хаустония",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбук блогі",
  "block.minecraft.bamboo_button": "Бамбук түйме",
  "block.minecraft.bamboo_door": "Бамбук есік",
  "block.minecraft.bamboo_fence": "Бамбук шарбақ",
  "block.minecraft.bamboo_fence_gate": "Бамбук қақпа",
  "block.minecraft.bamboo_hanging_sign": "Аспалы бамбук маңдайша",
  "block.minecraft.bamboo_mosaic": "Бамбук мозаика",
  "block.minecraft.bamboo_mosaic_slab": "Бамбук мозаика тақта",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбук мозаика тепкішек",
  "block.minecraft.bamboo_planks": "Бамбук тақтай",
  "block.minecraft.bamboo_pressure_plate": "Бамбук басқыш",
  "block.minecraft.bamboo_sapling": "Бамбук өскіні",
  "block.minecraft.bamboo_shelf": "Бамбук сөре",
  "block.minecraft.bamboo_sign": "Бамбук маңдайша",
  "block.minecraft.bamboo_slab": "Бамбук тақта",
  "block.minecraft.bamboo_stairs": "Бамбук тепкішек",
  "block.minecraft.bamboo_trapdoor": "Бамбук қақпақ",
  "block.minecraft.bamboo_wall_hanging_sign": "Дуалдағы аспалы бамбук маңдайша",
  "block.minecraft.bamboo_wall_sign": "Дуалдағы бамбук маңдайша",
  "block.minecraft.banner.base.black": "Қара түсті",
  "block.minecraft.banner.base.blue": "Көк түсті",
  "block.minecraft.banner.base.brown": "Қоңыр түсті",
  "block.minecraft.banner.base.cyan": "Көкзеңгір түсті",
  "block.minecraft.banner.base.gray": "Сұр түсті",
  "block.minecraft.banner.base.green": "Жасыл түсті",
  "block.minecraft.banner.base.light_blue": "Көгілдір түсті",
  "block.minecraft.banner.base.light_gray": "Боз түсті",
  "block.minecraft.banner.base.lime": "Көкжасыл түсті",
  "block.minecraft.banner.base.magenta": "Қызылкүрең түсті",
  "block.minecraft.banner.base.orange": "Сарғыш түсті",
  "block.minecraft.banner.base.pink": "Қызғылт түсті",
  "block.minecraft.banner.base.purple": "Күлгін түсті",
  "block.minecraft.banner.base.red": "Қызыл түсті",
  "block.minecraft.banner.base.white": "Ақ түсті",
  "block.minecraft.banner.base.yellow": "Сары түсті",
  "block.minecraft.banner.border.black": "Қара әдіп",
  "block.minecraft.banner.border.blue": "Көк әдіп",
  "block.minecraft.banner.border.brown": "Қоңыр әдіп",
  "block.minecraft.banner.border.cyan": "Көкзеңгір әдіп",
  "block.minecraft.banner.border.gray": "Сұр әдіп",
  "block.minecraft.banner.border.green": "Жасыл әдіп",
  "block.minecraft.banner.border.light_blue": "Көгілдір әдіп",
  "block.minecraft.banner.border.light_gray": "Боз әдіп",
  "block.minecraft.banner.border.lime": "Көкжасыл әдіп",
  "block.minecraft.banner.border.magenta": "Қызылкүрең әдіп",
  "block.minecraft.banner.border.orange": "Сарғыш әдіп",
  "block.minecraft.banner.border.pink": "Қызғылт әдіп",
  "block.minecraft.banner.border.purple": "Күлгін әдіп",
  "block.minecraft.banner.border.red": "Қызыл әдіп",
  "block.minecraft.banner.border.white": "Ақ әдіп",
  "block.minecraft.banner.border.yellow": "Сары әдіп",
  "block.minecraft.banner.bricks.black": "Қара кірпіш",
  "block.minecraft.banner.bricks.blue": "Көк кірпіш",
  "block.minecraft.banner.bricks.brown": "Қоңыр кірпіш",
  "block.minecraft.banner.bricks.cyan": "Көкзеңгір кірпіш",
  "block.minecraft.banner.bricks.gray": "Сұр кірпіш",
  "block.minecraft.banner.bricks.green": "Жасыл кірпіш",
  "block.minecraft.banner.bricks.light_blue": "Көгілдір кірпіш",
  "block.minecraft.banner.bricks.light_gray": "Боз кірпіш",
  "block.minecraft.banner.bricks.lime": "Көкжасыл кірпіш",
  "block.minecraft.banner.bricks.magenta": "Қызылкүрең кірпіш",
  "block.minecraft.banner.bricks.orange": "Сарғыш кірпіш",
  "block.minecraft.banner.bricks.pink": "Қызғылт кірпіш",
  "block.minecraft.banner.bricks.purple": "Күлгін кірпіш",
  "block.minecraft.banner.bricks.red": "Қызыл кірпіш",
  "block.minecraft.banner.bricks.white": "Ақ кірпіш",
  "block.minecraft.banner.bricks.yellow": "Сары кірпіш",
  "block.minecraft.banner.circle.black": "Қара шеңбер",
  "block.minecraft.banner.circle.blue": "Көк шеңбер",
  "block.minecraft.banner.circle.brown": "Қоңыр шеңбер",
  "block.minecraft.banner.circle.cyan": "Көкзеңгір шеңбер",
  "block.minecraft.banner.circle.gray": "Сұр шеңбер",
  "block.minecraft.banner.circle.green": "Жасыл шеңбер",
  "block.minecraft.banner.circle.light_blue": "Көгілдір шеңбер",
  "block.minecraft.banner.circle.light_gray": "Боз шеңбер",
  "block.minecraft.banner.circle.lime": "Көкжасыл шеңбер",
  "block.minecraft.banner.circle.magenta": "Қызылкүрең шеңбер",
  "block.minecraft.banner.circle.orange": "Сарғыш шеңбер",
  "block.minecraft.banner.circle.pink": "Қызғылт шеңбер",
  "block.minecraft.banner.circle.purple": "Күлгін шеңбер",
  "block.minecraft.banner.circle.red": "Қызыл шеңбер",
  "block.minecraft.banner.circle.white": "Ақ шеңбер",
  "block.minecraft.banner.circle.yellow": "Сары шеңбер",
  "block.minecraft.banner.creeper.black": "Қара крипер",
  "block.minecraft.banner.creeper.blue": "Көк крипер",
  "block.minecraft.banner.creeper.brown": "Қоңыр крипер",
  "block.minecraft.banner.creeper.cyan": "Көкзеңгір крипер",
  "block.minecraft.banner.creeper.gray": "Сұр крипер",
  "block.minecraft.banner.creeper.green": "Жасыл крипер",
  "block.minecraft.banner.creeper.light_blue": "Көгілдір крипер",
  "block.minecraft.banner.creeper.light_gray": "Боз крипер",
  "block.minecraft.banner.creeper.lime": "Көкжасыл крипер",
  "block.minecraft.banner.creeper.magenta": "Қызылкүрең крипер",
  "block.minecraft.banner.creeper.orange": "Сарғыш крипер",
  "block.minecraft.banner.creeper.pink": "Қызғылт крипер",
  "block.minecraft.banner.creeper.purple": "Күлгін крипер",
  "block.minecraft.banner.creeper.red": "Қызыл крипер",
  "block.minecraft.banner.creeper.white": "Ақ крипер",
  "block.minecraft.banner.creeper.yellow": "Сары крипер",
  "block.minecraft.banner.cross.black": "Қара айқыш",
  "block.minecraft.banner.cross.blue": "Көк айқыш",
  "block.minecraft.banner.cross.brown": "Қоңыр айқыш",
  "block.minecraft.banner.cross.cyan": "Көкзеңгір айқыш",
  "block.minecraft.banner.cross.gray": "Сұр айқыш",
  "block.minecraft.banner.cross.green": "Жасыл айқыш",
  "block.minecraft.banner.cross.light_blue": "Көгілдір айқыш",
  "block.minecraft.banner.cross.light_gray": "Боз айқыш",
  "block.minecraft.banner.cross.lime": "Көкжасыл айқыш",
  "block.minecraft.banner.cross.magenta": "Қызылкүрең айқыш",
  "block.minecraft.banner.cross.orange": "Сарғыш айқыш",
  "block.minecraft.banner.cross.pink": "Қызғылт айқыш",
  "block.minecraft.banner.cross.purple": "Күлгін айқыш",
  "block.minecraft.banner.cross.red": "Қызыл айқыш",
  "block.minecraft.banner.cross.white": "Ақ айқыш",
  "block.minecraft.banner.cross.yellow": "Сары айқыш",
  "block.minecraft.banner.curly_border.black": "Қара ирек әдіп",
  "block.minecraft.banner.curly_border.blue": "Көк ирек әдіп",
  "block.minecraft.banner.curly_border.brown": "Қоңыр ирек әдіп",
  "block.minecraft.banner.curly_border.cyan": "Көкзеңгір ирек әдіп",
  "block.minecraft.banner.curly_border.gray": "Сұр ирек әдіп",
  "block.minecraft.banner.curly_border.green": "Жасыл ирек әдіп",
  "block.minecraft.banner.curly_border.light_blue": "Көгілдір ирек әдіп",
  "block.minecraft.banner.curly_border.light_gray": "Боз ирек әдіп",
  "block.minecraft.banner.curly_border.lime": "Көкжасыл ирек әдіп",
  "block.minecraft.banner.curly_border.magenta": "Қызылкүрең ирек әдіп",
  "block.minecraft.banner.curly_border.orange": "Сарғыш ирек әдіп",
  "block.minecraft.banner.curly_border.pink": "Қызғылт ирек әдіп",
  "block.minecraft.banner.curly_border.purple": "Күлгін ирек әдіп",
  "block.minecraft.banner.curly_border.red": "Қызыл ирек әдіп",
  "block.minecraft.banner.curly_border.white": "Ақ ирек әдіп",
  "block.minecraft.banner.curly_border.yellow": "Сары ирек әдіп",
  "block.minecraft.banner.diagonal_left.black": "Қара сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.blue": "Көк сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.brown": "Қоңыр сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.cyan": "Көкзеңгір сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.gray": "Сұр сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.green": "Жасыл сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.light_blue": "Көгілдір сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.light_gray": "Боз сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.lime": "Көкжасыл сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.magenta": "Қызылкүрең сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.orange": "Сарғыш сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.pink": "Қызғылт сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.purple": "Күлгін сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.red": "Қызыл сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.white": "Ақ сол жақ қиыс",
  "block.minecraft.banner.diagonal_left.yellow": "Сары сол жақ қиыс",
  "block.minecraft.banner.diagonal_right.black": "Қара қиыс",
  "block.minecraft.banner.diagonal_right.blue": "Көк қиыс",
  "block.minecraft.banner.diagonal_right.brown": "Қоңыр қиыс",
  "block.minecraft.banner.diagonal_right.cyan": "Көкзеңгір қиыс",
  "block.minecraft.banner.diagonal_right.gray": "Сұр қиыс",
  "block.minecraft.banner.diagonal_right.green": "Жасыл қиыс",
  "block.minecraft.banner.diagonal_right.light_blue": "Көгілдір қиыс",
  "block.minecraft.banner.diagonal_right.light_gray": "Боз қиыс",
  "block.minecraft.banner.diagonal_right.lime": "Көкжасыл қиыс",
  "block.minecraft.banner.diagonal_right.magenta": "Қызылкүрең қиыс",
  "block.minecraft.banner.diagonal_right.orange": "Сарғыш қиыс",
  "block.minecraft.banner.diagonal_right.pink": "Қызғылт қиыс",
  "block.minecraft.banner.diagonal_right.purple": "Күлгін қиыс",
  "block.minecraft.banner.diagonal_right.red": "Қызыл қиыс",
  "block.minecraft.banner.diagonal_right.white": "Ақ қиыс",
  "block.minecraft.banner.diagonal_right.yellow": "Сары қиыс",
  "block.minecraft.banner.diagonal_up_left.black": "Қара теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.blue": "Көк теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.brown": "Қоңыр теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.cyan": "Көкзеңгір теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.gray": "Сұр теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.green": "Жасыл теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Көгілдір теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Боз теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.lime": "Көкжасыл теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.magenta": "Қызылкүрең теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.orange": "Сарғыш теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.pink": "Қызғылт теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.purple": "Күлгін теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.red": "Қызыл теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.white": "Ақ теріс қиыс",
  "block.minecraft.banner.diagonal_up_left.yellow": "Сары теріс қиыс",
  "block.minecraft.banner.diagonal_up_right.black": "Қара теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.blue": "Көк теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.brown": "Қоңыр теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.cyan": "Көкзеңгір теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.gray": "Сұр теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.green": "Жасыл теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Көгілдір теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Боз теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.lime": "Көкжасыл теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.magenta": "Қызылкүрең теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.orange": "Сарғыш теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.pink": "Қызғылт теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.purple": "Күлгін теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.red": "Қызыл теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.white": "Ақ теріс сол жақ қиыс",
  "block.minecraft.banner.diagonal_up_right.yellow": "Сары теріс сол жақ қиыс",
  "block.minecraft.banner.flow.black": "Қара ағыс",
  "block.minecraft.banner.flow.blue": "Көк ағыс",
  "block.minecraft.banner.flow.brown": "Қоңыр ағыс",
  "block.minecraft.banner.flow.cyan": "Көкзеңгір ағыс",
  "block.minecraft.banner.flow.gray": "Сұр ағыс",
  "block.minecraft.banner.flow.green": "Жасыл ағыс",
  "block.minecraft.banner.flow.light_blue": "Көгілдір ағыс",
  "block.minecraft.banner.flow.light_gray": "Боз ағыс",
  "block.minecraft.banner.flow.lime": "Көкжасыл ағыс",
  "block.minecraft.banner.flow.magenta": "Қызылкүрең ағыс",
  "block.minecraft.banner.flow.orange": "Сарғыш ағыс",
  "block.minecraft.banner.flow.pink": "Қызғылт ағыс",
  "block.minecraft.banner.flow.purple": "Күлгін ағыс",
  "block.minecraft.banner.flow.red": "Қызыл ағыс",
  "block.minecraft.banner.flow.white": "Ақ ағыс",
  "block.minecraft.banner.flow.yellow": "Сары ағыс",
  "block.minecraft.banner.flower.black": "Қара гүл",
  "block.minecraft.banner.flower.blue": "Көк гүл",
  "block.minecraft.banner.flower.brown": "Қоңыр гүл",
  "block.minecraft.banner.flower.cyan": "Көкзеңгір гүл",
  "block.minecraft.banner.flower.gray": "Сұр гүл",
  "block.minecraft.banner.flower.green": "Жасыл гүл",
  "block.minecraft.banner.flower.light_blue": "Көгілдір гүл",
  "block.minecraft.banner.flower.light_gray": "Боз гүл",
  "block.minecraft.banner.flower.lime": "Көкжасыл гүл",
  "block.minecraft.banner.flower.magenta": "Қызылкүрең гүл",
  "block.minecraft.banner.flower.orange": "Сарғыш гүл",
  "block.minecraft.banner.flower.pink": "Қызғылт гүл",
  "block.minecraft.banner.flower.purple": "Күлгін гүл",
  "block.minecraft.banner.flower.red": "Қызыл гүл",
  "block.minecraft.banner.flower.white": "Ақ гүл",
  "block.minecraft.banner.flower.yellow": "Сары гүл",
  "block.minecraft.banner.globe.black": "Қара глобус",
  "block.minecraft.banner.globe.blue": "Көк глобус",
  "block.minecraft.banner.globe.brown": "Қоңыр глобус",
  "block.minecraft.banner.globe.cyan": "Көкзеңгір глобус",
  "block.minecraft.banner.globe.gray": "Сұр глобус",
  "block.minecraft.banner.globe.green": "Жасыл глобус",
  "block.minecraft.banner.globe.light_blue": "Көгілдір глобус",
  "block.minecraft.banner.globe.light_gray": "Боз глобус",
  "block.minecraft.banner.globe.lime": "Көкжасыл глобус",
  "block.minecraft.banner.globe.magenta": "Қызылкүрең глобус",
  "block.minecraft.banner.globe.orange": "Сарғыш глобус",
  "block.minecraft.banner.globe.pink": "Қызғылт глобус",
  "block.minecraft.banner.globe.purple": "Күлгін глобус",
  "block.minecraft.banner.globe.red": "Қызыл глобус",
  "block.minecraft.banner.globe.white": "Ақ глобус",
  "block.minecraft.banner.globe.yellow": "Сары глобус",
  "block.minecraft.banner.gradient.black": "Қара градиент",
  "block.minecraft.banner.gradient.blue": "Көк градиент",
  "block.minecraft.banner.gradient.brown": "Қоңыр градиент",
  "block.minecraft.banner.gradient.cyan": "Көкзеңгір градиент",
  "block.minecraft.banner.gradient.gray": "Сұр градиент",
  "block.minecraft.banner.gradient.green": "Жасыл градиент",
  "block.minecraft.banner.gradient.light_blue": "Көгілдір градиент",
  "block.minecraft.banner.gradient.light_gray": "Боз градиент",
  "block.minecraft.banner.gradient.lime": "Көкжасыл градиент",
  "block.minecraft.banner.gradient.magenta": "Қызылкүрең градиент",
  "block.minecraft.banner.gradient.orange": "Сарғыш градиент",
  "block.minecraft.banner.gradient.pink": "Қызғылт градиент",
  "block.minecraft.banner.gradient.purple": "Күлгін градиент",
  "block.minecraft.banner.gradient.red": "Қызыл градиент",
  "block.minecraft.banner.gradient.white": "Ақ градиент",
  "block.minecraft.banner.gradient.yellow": "Сары градиент",
  "block.minecraft.banner.gradient_up.black": "Қара теріс градиент",
  "block.minecraft.banner.gradient_up.blue": "Көк теріс градиент",
  "block.minecraft.banner.gradient_up.brown": "Қоңыр теріс градиент",
  "block.minecraft.banner.gradient_up.cyan": "Көкзеңгір теріс градиент",
  "block.minecraft.banner.gradient_up.gray": "Сұр теріс градиент",
  "block.minecraft.banner.gradient_up.green": "Жасыл теріс градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Көгілдір теріс градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Көгілдір теріс градиент",
  "block.minecraft.banner.gradient_up.lime": "Көкжасыл теріс градиент",
  "block.minecraft.banner.gradient_up.magenta": "Қызылкүрең теріс градиент",
  "block.minecraft.banner.gradient_up.orange": "Сарғыш теріс градиент",
  "block.minecraft.banner.gradient_up.pink": "Қызғылт теріс градиент",
  "block.minecraft.banner.gradient_up.purple": "Күлгін теріс градиент",
  "block.minecraft.banner.gradient_up.red": "Қызыл теріс градиент",
  "block.minecraft.banner.gradient_up.white": "Ақ теріс градиент",
  "block.minecraft.banner.gradient_up.yellow": "Сары теріс градиент",
  "block.minecraft.banner.guster.black": "Қара құйын",
  "block.minecraft.banner.guster.blue": "Көк құйын",
  "block.minecraft.banner.guster.brown": "Қоңыр құйын",
  "block.minecraft.banner.guster.cyan": "Көкзеңгір құйын",
  "block.minecraft.banner.guster.gray": "Сұр құйын",
  "block.minecraft.banner.guster.green": "Жасыл құйын",
  "block.minecraft.banner.guster.light_blue": "Көгілдір құйын",
  "block.minecraft.banner.guster.light_gray": "Боз құйын",
  "block.minecraft.banner.guster.lime": "Көкжасыл құйын",
  "block.minecraft.banner.guster.magenta": "Қызылкүрең құйын",
  "block.minecraft.banner.guster.orange": "Сарғыш құйын",
  "block.minecraft.banner.guster.pink": "Қызғылт құйын",
  "block.minecraft.banner.guster.purple": "Күлгін құйын",
  "block.minecraft.banner.guster.red": "Қызыл құйын",
  "block.minecraft.banner.guster.white": "Ақ құйын",
  "block.minecraft.banner.guster.yellow": "Сары құйын",
  "block.minecraft.banner.half_horizontal.black": "Қара жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.blue": "Көк жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.brown": "Қоңыр жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.cyan": "Көкзеңгір жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.gray": "Сұр жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.green": "Жасыл жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.light_blue": "Көгілдір жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.light_gray": "Боз жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.lime": "Көкжасыл жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.magenta": "Қызылкүрең жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.orange": "Сарғыш жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.pink": "Қызғылт жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.purple": "Күлгін жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.red": "Қызыл жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.white": "Ақ жоғарғы жақ",
  "block.minecraft.banner.half_horizontal.yellow": "Сары жоғарғы жақ",
  "block.minecraft.banner.half_horizontal_bottom.black": "Қара төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Көк төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Қоңыр төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Көкзеңгір төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сұр төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.green": "Жасыл төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Көгілдір төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Боз төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Көкжасыл төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Қызылкүрең төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Сарғыш төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Қызғылт төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Күлгін төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.red": "Қызыл төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.white": "Ақ төменгі жақ",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Сары төменгі жақ",
  "block.minecraft.banner.half_vertical.black": "Қара сол жақ",
  "block.minecraft.banner.half_vertical.blue": "Көк сол жақ",
  "block.minecraft.banner.half_vertical.brown": "Қоңыр сол жақ",
  "block.minecraft.banner.half_vertical.cyan": "Көкзеңгір сол жақ",
  "block.minecraft.banner.half_vertical.gray": "Сұр сол жақ",
  "block.minecraft.banner.half_vertical.green": "Жасыл сол жақ",
  "block.minecraft.banner.half_vertical.light_blue": "Көгілдір сол жақ",
  "block.minecraft.banner.half_vertical.light_gray": "Боз сол жақ",
  "block.minecraft.banner.half_vertical.lime": "Көкжасыл сол жақ",
  "block.minecraft.banner.half_vertical.magenta": "Қызылкүрең сол жақ",
  "block.minecraft.banner.half_vertical.orange": "Сарғыш сол жақ",
  "block.minecraft.banner.half_vertical.pink": "Қызғылт сол жақ",
  "block.minecraft.banner.half_vertical.purple": "Күлгін сол жақ",
  "block.minecraft.banner.half_vertical.red": "Қызыл сол жақ",
  "block.minecraft.banner.half_vertical.white": "Ақ сол жақ",
  "block.minecraft.banner.half_vertical.yellow": "Сары сол жақ",
  "block.minecraft.banner.half_vertical_right.black": "Қара оң жақ",
  "block.minecraft.banner.half_vertical_right.blue": "Көк оң жақ",
  "block.minecraft.banner.half_vertical_right.brown": "Қоңыр оң жақ",
  "block.minecraft.banner.half_vertical_right.cyan": "Көкзеңгір оң жақ",
  "block.minecraft.banner.half_vertical_right.gray": "Сұр оң жақ",
  "block.minecraft.banner.half_vertical_right.green": "Жасыл оң жақ",
  "block.minecraft.banner.half_vertical_right.light_blue": "Көгілдір оң жақ",
  "block.minecraft.banner.half_vertical_right.light_gray": "Боз оң жақ",
  "block.minecraft.banner.half_vertical_right.lime": "Көкжасыл оң жақ",
  "block.minecraft.banner.half_vertical_right.magenta": "Қызылкүрең оң жақ",
  "block.minecraft.banner.half_vertical_right.orange": "Сарғыш оң жақ",
  "block.minecraft.banner.half_vertical_right.pink": "Қызғылт оң жақ",
  "block.minecraft.banner.half_vertical_right.purple": "Күлгін оң жақ",
  "block.minecraft.banner.half_vertical_right.red": "Қызыл оң жақ",
  "block.minecraft.banner.half_vertical_right.white": "Ақ оң жақ",
  "block.minecraft.banner.half_vertical_right.yellow": "Сары оң жақ",
  "block.minecraft.banner.mojang.black": "Қара бірдеңе",
  "block.minecraft.banner.mojang.blue": "Көк бірдеңе",
  "block.minecraft.banner.mojang.brown": "Қоңыр бірдеңе",
  "block.minecraft.banner.mojang.cyan": "Көкзеңгір бірдеңе",
  "block.minecraft.banner.mojang.gray": "Сұр бірдеңе",
  "block.minecraft.banner.mojang.green": "Жасыл бірдеңе",
  "block.minecraft.banner.mojang.light_blue": "Көгілдір бірдеңе",
  "block.minecraft.banner.mojang.light_gray": "Боз бірдеңе",
  "block.minecraft.banner.mojang.lime": "Көкжасыл бірдеңе",
  "block.minecraft.banner.mojang.magenta": "Қызылкүрең бірдеңе",
  "block.minecraft.banner.mojang.orange": "Сарғыш бірдеңе",
  "block.minecraft.banner.mojang.pink": "Қызғылт бірдеңе",
  "block.minecraft.banner.mojang.purple": "Күлгін бірдеңе",
  "block.minecraft.banner.mojang.red": "Қызыл бірдеңе",
  "block.minecraft.banner.mojang.white": "Ақ бірдеңе",
  "block.minecraft.banner.mojang.yellow": "Сары бірдеңе",
  "block.minecraft.banner.piglin.black": "Қара тұмсық",
  "block.minecraft.banner.piglin.blue": "Көк тұмсық",
  "block.minecraft.banner.piglin.brown": "Қоңыр тұмсық",
  "block.minecraft.banner.piglin.cyan": "Көкзеңгір тұмсық",
  "block.minecraft.banner.piglin.gray": "Сұр тұмсық",
  "block.minecraft.banner.piglin.green": "Жасыл тұмсық",
  "block.minecraft.banner.piglin.light_blue": "Көгілдір тұмсық",
  "block.minecraft.banner.piglin.light_gray": "Боз тұмсық",
  "block.minecraft.banner.piglin.lime": "Көкжасыл тұмсық",
  "block.minecraft.banner.piglin.magenta": "Қызылкүрең тұмсық",
  "block.minecraft.banner.piglin.orange": "Сарғыш тұмсық",
  "block.minecraft.banner.piglin.pink": "Қызғылт тұмсық",
  "block.minecraft.banner.piglin.purple": "Күлгін тұмсық",
  "block.minecraft.banner.piglin.red": "Қызыл тұмсық",
  "block.minecraft.banner.piglin.white": "Ақ тұмсық",
  "block.minecraft.banner.piglin.yellow": "Сары тұмсық",
  "block.minecraft.banner.rhombus.black": "Қара қиықша",
  "block.minecraft.banner.rhombus.blue": "Көк қиықша",
  "block.minecraft.banner.rhombus.brown": "Қоңыр қиықша",
  "block.minecraft.banner.rhombus.cyan": "Көкзеңгір қиықша",
  "block.minecraft.banner.rhombus.gray": "Сұр қиықша",
  "block.minecraft.banner.rhombus.green": "Жасыл қиықша",
  "block.minecraft.banner.rhombus.light_blue": "Көгілдір қиықша",
  "block.minecraft.banner.rhombus.light_gray": "Боз қиықша",
  "block.minecraft.banner.rhombus.lime": "Көкжасыл қиықша",
  "block.minecraft.banner.rhombus.magenta": "Қызылкүрең қиықша",
  "block.minecraft.banner.rhombus.orange": "Сарғыш қиықша",
  "block.minecraft.banner.rhombus.pink": "Қызғылт қиықша",
  "block.minecraft.banner.rhombus.purple": "Күлгін қиықша",
  "block.minecraft.banner.rhombus.red": "Қызыл қиықша",
  "block.minecraft.banner.rhombus.white": "Ақ қиықша",
  "block.minecraft.banner.rhombus.yellow": "Сары қиықша",
  "block.minecraft.banner.skull.black": "Қара бас сүйек",
  "block.minecraft.banner.skull.blue": "Көк бас сүйек",
  "block.minecraft.banner.skull.brown": "Қоңыр бас сүйек",
  "block.minecraft.banner.skull.cyan": "Көкзеңгір бас сүйек",
  "block.minecraft.banner.skull.gray": "Сұр бас сүйек",
  "block.minecraft.banner.skull.green": "Жасыл бас сүйек",
  "block.minecraft.banner.skull.light_blue": "Көгілдір бас сүйек",
  "block.minecraft.banner.skull.light_gray": "Боз бас сүйек",
  "block.minecraft.banner.skull.lime": "Көкжасыл бас сүйек",
  "block.minecraft.banner.skull.magenta": "Қызылкүрең бас сүйек",
  "block.minecraft.banner.skull.orange": "Сарғыш бас сүйек",
  "block.minecraft.banner.skull.pink": "Қызғылт бас сүйек",
  "block.minecraft.banner.skull.purple": "Күлгін бас сүйек",
  "block.minecraft.banner.skull.red": "Қызыл бас сүйек",
  "block.minecraft.banner.skull.white": "Ақ бас сүйек",
  "block.minecraft.banner.skull.yellow": "Сары бас сүйек",
  "block.minecraft.banner.small_stripes.black": "Қара жолақ",
  "block.minecraft.banner.small_stripes.blue": "Көк жолақ",
  "block.minecraft.banner.small_stripes.brown": "Қоңыр жолақ",
  "block.minecraft.banner.small_stripes.cyan": "Көкзеңгір жолақ",
  "block.minecraft.banner.small_stripes.gray": "Сұр жолақ",
  "block.minecraft.banner.small_stripes.green": "Жасыл жолақ",
  "block.minecraft.banner.small_stripes.light_blue": "Көгілдір жолақ",
  "block.minecraft.banner.small_stripes.light_gray": "Боз жолақ",
  "block.minecraft.banner.small_stripes.lime": "Көкжасыл жолақ",
  "block.minecraft.banner.small_stripes.magenta": "Қызылкүрең жолақ",
  "block.minecraft.banner.small_stripes.orange": "Сарғыш жолақ",
  "block.minecraft.banner.small_stripes.pink": "Қызғылт жолақ",
  "block.minecraft.banner.small_stripes.purple": "Күлгін жолақ",
  "block.minecraft.banner.small_stripes.red": "Қызыл жолақ",
  "block.minecraft.banner.small_stripes.white": "Ақ жолақ",
  "block.minecraft.banner.small_stripes.yellow": "Сары жолақ",
  "block.minecraft.banner.square_bottom_left.black": "Қара сол жақ асты",
  "block.minecraft.banner.square_bottom_left.blue": "Көк сол жақ асты",
  "block.minecraft.banner.square_bottom_left.brown": "Қоңыр сол жақ асты",
  "block.minecraft.banner.square_bottom_left.cyan": "Көкзеңгір сол жақ асты",
  "block.minecraft.banner.square_bottom_left.gray": "Сұр сол жақ асты",
  "block.minecraft.banner.square_bottom_left.green": "Жасыл сол жақ асты",
  "block.minecraft.banner.square_bottom_left.light_blue": "Көгілдір сол жақ асты",
  "block.minecraft.banner.square_bottom_left.light_gray": "Боз сол жақ асты",
  "block.minecraft.banner.square_bottom_left.lime": "Көкжасыл сол жақ асты",
  "block.minecraft.banner.square_bottom_left.magenta": "Қызылкүрең сол жақ асты",
  "block.minecraft.banner.square_bottom_left.orange": "Сарғыш сол жақ асты",
  "block.minecraft.banner.square_bottom_left.pink": "Қызғылт сол жақ асты",
  "block.minecraft.banner.square_bottom_left.purple": "Күлгін сол жақ асты",
  "block.minecraft.banner.square_bottom_left.red": "Қызыл сол жақ асты",
  "block.minecraft.banner.square_bottom_left.white": "Ақ сол жақ асты",
  "block.minecraft.banner.square_bottom_left.yellow": "Сары сол жақ асты",
  "block.minecraft.banner.square_bottom_right.black": "Қара оң жақ асты",
  "block.minecraft.banner.square_bottom_right.blue": "Көк оң жақ асты",
  "block.minecraft.banner.square_bottom_right.brown": "Қоңыр оң жақ асты",
  "block.minecraft.banner.square_bottom_right.cyan": "Көкзеңгір оң жақ асты",
  "block.minecraft.banner.square_bottom_right.gray": "Сұр оң жақ асты",
  "block.minecraft.banner.square_bottom_right.green": "Жасыл оң жақ асты",
  "block.minecraft.banner.square_bottom_right.light_blue": "Көгілдір оң жақ асты",
  "block.minecraft.banner.square_bottom_right.light_gray": "Боз оң жақ асты",
  "block.minecraft.banner.square_bottom_right.lime": "Көкжасыл оң жақ асты",
  "block.minecraft.banner.square_bottom_right.magenta": "Қызылкүрең оң жақ асты",
  "block.minecraft.banner.square_bottom_right.orange": "Сарғыш оң жақ асты",
  "block.minecraft.banner.square_bottom_right.pink": "Қызғылт оң жақ асты",
  "block.minecraft.banner.square_bottom_right.purple": "Күлгін оң жақ асты",
  "block.minecraft.banner.square_bottom_right.red": "Қызыл оң жақ асты",
  "block.minecraft.banner.square_bottom_right.white": "Ақ оң жақ асты",
  "block.minecraft.banner.square_bottom_right.yellow": "Сары оң жақ асты",
  "block.minecraft.banner.square_top_left.black": "Қара сол жақ үсті",
  "block.minecraft.banner.square_top_left.blue": "Көк сол жақ үсті",
  "block.minecraft.banner.square_top_left.brown": "Қоңыр сол жақ үсті",
  "block.minecraft.banner.square_top_left.cyan": "Көкзеңгір сол жақ үсті",
  "block.minecraft.banner.square_top_left.gray": "Сұр сол жақ үсті",
  "block.minecraft.banner.square_top_left.green": "Жасыл сол жақ үсті",
  "block.minecraft.banner.square_top_left.light_blue": "Көгілдір сол жақ үсті",
  "block.minecraft.banner.square_top_left.light_gray": "Боз сол жақ үсті",
  "block.minecraft.banner.square_top_left.lime": "Көкжасыл сол жақ үсті",
  "block.minecraft.banner.square_top_left.magenta": "Қызылкүрең сол жақ үсті",
  "block.minecraft.banner.square_top_left.orange": "Сарғыш сол жақ үсті",
  "block.minecraft.banner.square_top_left.pink": "Қызғылт сол жақ үсті",
  "block.minecraft.banner.square_top_left.purple": "Күлгін сол жақ үсті",
  "block.minecraft.banner.square_top_left.red": "Қызыл сол жақ үсті",
  "block.minecraft.banner.square_top_left.white": "Ақ сол жақ үсті",
  "block.minecraft.banner.square_top_left.yellow": "Сары сол жақ үсті",
  "block.minecraft.banner.square_top_right.black": "Қара оң жақ үсті",
  "block.minecraft.banner.square_top_right.blue": "Көк оң жақ үсті",
  "block.minecraft.banner.square_top_right.brown": "Қоңыр оң жақ үсті",
  "block.minecraft.banner.square_top_right.cyan": "Көкзеңгір оң жақ үсті",
  "block.minecraft.banner.square_top_right.gray": "Сұр оң жақ үсті",
  "block.minecraft.banner.square_top_right.green": "Жасыл оң жақ үсті",
  "block.minecraft.banner.square_top_right.light_blue": "Көгілдір оң жақ үсті",
  "block.minecraft.banner.square_top_right.light_gray": "Боз оң жақ үсті",
  "block.minecraft.banner.square_top_right.lime": "Көкжасыл оң жақ үсті",
  "block.minecraft.banner.square_top_right.magenta": "Қызылкүрең оң жақ үсті",
  "block.minecraft.banner.square_top_right.orange": "Сарғыш оң жақ үсті",
  "block.minecraft.banner.square_top_right.pink": "Қызғылт оң жақ үсті",
  "block.minecraft.banner.square_top_right.purple": "Күлгін оң жақ үсті",
  "block.minecraft.banner.square_top_right.red": "Қызыл оң жақ үсті",
  "block.minecraft.banner.square_top_right.white": "Ақ оң жақ үсті",
  "block.minecraft.banner.square_top_right.yellow": "Сары оң жақ үсті",
  "block.minecraft.banner.straight_cross.black": "Қара кірес",
  "block.minecraft.banner.straight_cross.blue": "Көк кірес",
  "block.minecraft.banner.straight_cross.brown": "Қоңыр кірес",
  "block.minecraft.banner.straight_cross.cyan": "Көкзеңгір кірес",
  "block.minecraft.banner.straight_cross.gray": "Сұр кірес",
  "block.minecraft.banner.straight_cross.green": "Жасыл кірес",
  "block.minecraft.banner.straight_cross.light_blue": "Көгілдір кірес",
  "block.minecraft.banner.straight_cross.light_gray": "Боз кірес",
  "block.minecraft.banner.straight_cross.lime": "Көкжасыл кірес",
  "block.minecraft.banner.straight_cross.magenta": "Қызылкүрең кірес",
  "block.minecraft.banner.straight_cross.orange": "Сарғыш кірес",
  "block.minecraft.banner.straight_cross.pink": "Қызғылт кірес",
  "block.minecraft.banner.straight_cross.purple": "Күлгін кірес",
  "block.minecraft.banner.straight_cross.red": "Қызыл кірес",
  "block.minecraft.banner.straight_cross.white": "Ақ кірес",
  "block.minecraft.banner.straight_cross.yellow": "Сары кірес",
  "block.minecraft.banner.stripe_bottom.black": "Қара асты",
  "block.minecraft.banner.stripe_bottom.blue": "Көк асты",
  "block.minecraft.banner.stripe_bottom.brown": "Қоңыр асты",
  "block.minecraft.banner.stripe_bottom.cyan": "Көкзеңгір асты",
  "block.minecraft.banner.stripe_bottom.gray": "Сұр асты",
  "block.minecraft.banner.stripe_bottom.green": "Жасыл асты",
  "block.minecraft.banner.stripe_bottom.light_blue": "Көгілдір асты",
  "block.minecraft.banner.stripe_bottom.light_gray": "Боз асты",
  "block.minecraft.banner.stripe_bottom.lime": "Көкжасыл асты",
  "block.minecraft.banner.stripe_bottom.magenta": "Қызылкүрең асты",
  "block.minecraft.banner.stripe_bottom.orange": "Сарғыш асты",
  "block.minecraft.banner.stripe_bottom.pink": "Қызғылт асты",
  "block.minecraft.banner.stripe_bottom.purple": "Күлгін асты",
  "block.minecraft.banner.stripe_bottom.red": "Қызыл асты",
  "block.minecraft.banner.stripe_bottom.white": "Ақ асты",
  "block.minecraft.banner.stripe_bottom.yellow": "Сары асты",
  "block.minecraft.banner.stripe_center.black": "Қара тілкем",
  "block.minecraft.banner.stripe_center.blue": "Көк тілкем",
  "block.minecraft.banner.stripe_center.brown": "Қоңыр тілкем",
  "block.minecraft.banner.stripe_center.cyan": "Көкзеңгір тілкем",
  "block.minecraft.banner.stripe_center.gray": "Сұр тілкем",
  "block.minecraft.banner.stripe_center.green": "Жасыл тілкем",
  "block.minecraft.banner.stripe_center.light_blue": "Көгілдір тілкем",
  "block.minecraft.banner.stripe_center.light_gray": "Боз тілкем",
  "block.minecraft.banner.stripe_center.lime": "Көкжасыл тілкем",
  "block.minecraft.banner.stripe_center.magenta": "Қызылкүрең тілкем",
  "block.minecraft.banner.stripe_center.orange": "Сарғыш тілкем",
  "block.minecraft.banner.stripe_center.pink": "Қызғылт тілкем",
  "block.minecraft.banner.stripe_center.purple": "Күлгін тілкем",
  "block.minecraft.banner.stripe_center.red": "Қызыл тілкем",
  "block.minecraft.banner.stripe_center.white": "Ақ тілкем",
  "block.minecraft.banner.stripe_center.yellow": "Сары тілкем",
  "block.minecraft.banner.stripe_downleft.black": "Қара теріс қияс",
  "block.minecraft.banner.stripe_downleft.blue": "Көк теріс қияс",
  "block.minecraft.banner.stripe_downleft.brown": "Қоңыр теріс қияс",
  "block.minecraft.banner.stripe_downleft.cyan": "Көкзеңгір теріс қияс",
  "block.minecraft.banner.stripe_downleft.gray": "Сұр теріс қияс",
  "block.minecraft.banner.stripe_downleft.green": "Жасыл теріс қияс",
  "block.minecraft.banner.stripe_downleft.light_blue": "Көгілдір теріс қияс",
  "block.minecraft.banner.stripe_downleft.light_gray": "Боз теріс қияс",
  "block.minecraft.banner.stripe_downleft.lime": "Көкжасыл теріс қияс",
  "block.minecraft.banner.stripe_downleft.magenta": "Қызылкүрең теріс қияс",
  "block.minecraft.banner.stripe_downleft.orange": "Сарғыш теріс қияс",
  "block.minecraft.banner.stripe_downleft.pink": "Қызғылт теріс қияс",
  "block.minecraft.banner.stripe_downleft.purple": "Күлгін теріс қияс",
  "block.minecraft.banner.stripe_downleft.red": "Қызыл теріс қияс",
  "block.minecraft.banner.stripe_downleft.white": "Ақ теріс қияс",
  "block.minecraft.banner.stripe_downleft.yellow": "Сары теріс қияс",
  "block.minecraft.banner.stripe_downright.black": "Қара қияс",
  "block.minecraft.banner.stripe_downright.blue": "Көк қияс",
  "block.minecraft.banner.stripe_downright.brown": "Қоңыр қияс",
  "block.minecraft.banner.stripe_downright.cyan": "Көкзеңгір қияс",
  "block.minecraft.banner.stripe_downright.gray": "Сұр қияс",
  "block.minecraft.banner.stripe_downright.green": "Жасыл қияс",
  "block.minecraft.banner.stripe_downright.light_blue": "Көгілдір қияс",
  "block.minecraft.banner.stripe_downright.light_gray": "Боз қияс",
  "block.minecraft.banner.stripe_downright.lime": "Көкжасыл қияс",
  "block.minecraft.banner.stripe_downright.magenta": "Қызылкүрең қияс",
  "block.minecraft.banner.stripe_downright.orange": "Сарғыш қияс",
  "block.minecraft.banner.stripe_downright.pink": "Қызғылт қияс",
  "block.minecraft.banner.stripe_downright.purple": "Күлгін қияс",
  "block.minecraft.banner.stripe_downright.red": "Қызыл қияс",
  "block.minecraft.banner.stripe_downright.white": "Ақ қияс",
  "block.minecraft.banner.stripe_downright.yellow": "Сары қияс",
  "block.minecraft.banner.stripe_left.black": "Қара сол жақ тілкем",
  "block.minecraft.banner.stripe_left.blue": "Көк сол жақ тілкем",
  "block.minecraft.banner.stripe_left.brown": "Қоңыр сол жақ тілкем",
  "block.minecraft.banner.stripe_left.cyan": "Көкзеңгір сол жақ тілкем",
  "block.minecraft.banner.stripe_left.gray": "Сұр сол жақ тілкем",
  "block.minecraft.banner.stripe_left.green": "Жасыл сол жақ тілкем",
  "block.minecraft.banner.stripe_left.light_blue": "Көгілдір сол жақ тілкем",
  "block.minecraft.banner.stripe_left.light_gray": "Боз сол жақ тілкем",
  "block.minecraft.banner.stripe_left.lime": "Көкжасыл сол жақ тілкем",
  "block.minecraft.banner.stripe_left.magenta": "Қызылкүрең оң жақ тілкем",
  "block.minecraft.banner.stripe_left.orange": "Сарғыш сол жақ тілкем",
  "block.minecraft.banner.stripe_left.pink": "Қызғылт сол жақ тілкем",
  "block.minecraft.banner.stripe_left.purple": "Күлгін сол жақ тілкем",
  "block.minecraft.banner.stripe_left.red": "Қызыл сол жақ тілкем",
  "block.minecraft.banner.stripe_left.white": "Ақ сол жақ тілкем",
  "block.minecraft.banner.stripe_left.yellow": "Сары сол жақ тілкем",
  "block.minecraft.banner.stripe_middle.black": "Қара белдеу",
  "block.minecraft.banner.stripe_middle.blue": "Көк белдеу",
  "block.minecraft.banner.stripe_middle.brown": "Қоңыр белдеу",
  "block.minecraft.banner.stripe_middle.cyan": "Көкзеңгір белдеу",
  "block.minecraft.banner.stripe_middle.gray": "Сұр белдеу",
  "block.minecraft.banner.stripe_middle.green": "Жасыл белдеу",
  "block.minecraft.banner.stripe_middle.light_blue": "Көгілдір белдеу",
  "block.minecraft.banner.stripe_middle.light_gray": "Боз белдеу",
  "block.minecraft.banner.stripe_middle.lime": "Көкжасыл белдеу",
  "block.minecraft.banner.stripe_middle.magenta": "Қызылкүрең белдеу",
  "block.minecraft.banner.stripe_middle.orange": "Сарғыш белдеу",
  "block.minecraft.banner.stripe_middle.pink": "Қызғылт белдеу",
  "block.minecraft.banner.stripe_middle.purple": "Күлгін белдеу",
  "block.minecraft.banner.stripe_middle.red": "Қызыл белдеу",
  "block.minecraft.banner.stripe_middle.white": "Ақ белдеу",
  "block.minecraft.banner.stripe_middle.yellow": "Сары белдеу",
  "block.minecraft.banner.stripe_right.black": "Қара оң жақ тілкем",
  "block.minecraft.banner.stripe_right.blue": "Көк оң жақ тілкем",
  "block.minecraft.banner.stripe_right.brown": "Қоңыр оң жақ тілкем",
  "block.minecraft.banner.stripe_right.cyan": "Көкзеңгір оң жақ тілкем",
  "block.minecraft.banner.stripe_right.gray": "Сұр оң жақ тілкем",
  "block.minecraft.banner.stripe_right.green": "Жасыл оң жақ тілкем",
  "block.minecraft.banner.stripe_right.light_blue": "Көгілдір оң жақ тілкем",
  "block.minecraft.banner.stripe_right.light_gray": "Боз оң жақ тілкем",
  "block.minecraft.banner.stripe_right.lime": "Көкжасыл оң жақ тілкем",
  "block.minecraft.banner.stripe_right.magenta": "Қызылкүрең сол жақ тілкем",
  "block.minecraft.banner.stripe_right.orange": "Сарғыш оң жақ тілкем",
  "block.minecraft.banner.stripe_right.pink": "Қызғылт оң жақ тілкем",
  "block.minecraft.banner.stripe_right.purple": "Күлгін оң жақ тілкем",
  "block.minecraft.banner.stripe_right.red": "Қызыл оң жақ тілкем",
  "block.minecraft.banner.stripe_right.white": "Ақ оң жақ тілкем",
  "block.minecraft.banner.stripe_right.yellow": "Сары оң жақ тілкем",
  "block.minecraft.banner.stripe_top.black": "Қара үсті",
  "block.minecraft.banner.stripe_top.blue": "Көк үсті",
  "block.minecraft.banner.stripe_top.brown": "Қоңыр үсті",
  "block.minecraft.banner.stripe_top.cyan": "Көкзеңгір үсті",
  "block.minecraft.banner.stripe_top.gray": "Сұр үсті",
  "block.minecraft.banner.stripe_top.green": "Жасыл үсті",
  "block.minecraft.banner.stripe_top.light_blue": "Көгілдір үсті",
  "block.minecraft.banner.stripe_top.light_gray": "Боз үсті",
  "block.minecraft.banner.stripe_top.lime": "Көкжасыл үсті",
  "block.minecraft.banner.stripe_top.magenta": "Қызылкүрең үсті",
  "block.minecraft.banner.stripe_top.orange": "Сарғыш үсті",
  "block.minecraft.banner.stripe_top.pink": "Қызғылт үсті",
  "block.minecraft.banner.stripe_top.purple": "Күлгін үсті",
  "block.minecraft.banner.stripe_top.red": "Қызыл үсті",
  "block.minecraft.banner.stripe_top.white": "Ақ үсті",
  "block.minecraft.banner.stripe_top.yellow": "Сары үсті",
  "block.minecraft.banner.triangle_bottom.black": "Қара үшкіл",
  "block.minecraft.banner.triangle_bottom.blue": "Көк үшкіл",
  "block.minecraft.banner.triangle_bottom.brown": "Қоңыр үшкіл",
  "block.minecraft.banner.triangle_bottom.cyan": "Көкзеңгір үшкіл",
  "block.minecraft.banner.triangle_bottom.gray": "Сұр үшкіл",
  "block.minecraft.banner.triangle_bottom.green": "Жасыл үшкіл",
  "block.minecraft.banner.triangle_bottom.light_blue": "Көгілдір үшкіл",
  "block.minecraft.banner.triangle_bottom.light_gray": "Боз үшкіл",
  "block.minecraft.banner.triangle_bottom.lime": "Көкжасыл үшкіл",
  "block.minecraft.banner.triangle_bottom.magenta": "Қызылкүрең үшкіл",
  "block.minecraft.banner.triangle_bottom.orange": "Сарғыш үшкіл",
  "block.minecraft.banner.triangle_bottom.pink": "Қызғылт үшкіл",
  "block.minecraft.banner.triangle_bottom.purple": "Күлгін үшкіл",
  "block.minecraft.banner.triangle_bottom.red": "Қызыл үшкіл",
  "block.minecraft.banner.triangle_bottom.white": "Ақ үшкіл",
  "block.minecraft.banner.triangle_bottom.yellow": "Сары үшкіл",
  "block.minecraft.banner.triangle_top.black": "Қара теріс үшкіл",
  "block.minecraft.banner.triangle_top.blue": "Көк теріс үшкіл",
  "block.minecraft.banner.triangle_top.brown": "Қоңыр теріс үшкіл",
  "block.minecraft.banner.triangle_top.cyan": "Көкзеңгір теріс үшкіл",
  "block.minecraft.banner.triangle_top.gray": "Сұр теріс үшкіл",
  "block.minecraft.banner.triangle_top.green": "Жасыл теріс үшкіл",
  "block.minecraft.banner.triangle_top.light_blue": "Көгілдір теріс үшкіл",
  "block.minecraft.banner.triangle_top.light_gray": "Боз теріс үшкіл",
  "block.minecraft.banner.triangle_top.lime": "Көкжасыл теріс үшкіл",
  "block.minecraft.banner.triangle_top.magenta": "Қызылкүрең теріс үшкіл",
  "block.minecraft.banner.triangle_top.orange": "Сарғыш теріс үшкіл",
  "block.minecraft.banner.triangle_top.pink": "Қызғылт теріс үшкіл",
  "block.minecraft.banner.triangle_top.purple": "Күлгін теріс үшкіл",
  "block.minecraft.banner.triangle_top.red": "Қызыл теріс үшкіл",
  "block.minecraft.banner.triangle_top.white": "Ақ теріс үшкіл",
  "block.minecraft.banner.triangle_top.yellow": "Сары теріс үшкіл",
  "block.minecraft.banner.triangles_bottom.black": "Қара кертік асты",
  "block.minecraft.banner.triangles_bottom.blue": "Көк кертік асты",
  "block.minecraft.banner.triangles_bottom.brown": "Қоңыр кертік асты",
  "block.minecraft.banner.triangles_bottom.cyan": "Көкзеңгір кертік асты",
  "block.minecraft.banner.triangles_bottom.gray": "Сұр кертік асты",
  "block.minecraft.banner.triangles_bottom.green": "Жасыл кертік асты",
  "block.minecraft.banner.triangles_bottom.light_blue": "Көгілдір кертік асты",
  "block.minecraft.banner.triangles_bottom.light_gray": "Боз кертік асты",
  "block.minecraft.banner.triangles_bottom.lime": "Көкжасыл кертік асты",
  "block.minecraft.banner.triangles_bottom.magenta": "Қызылкүрең кертік асты",
  "block.minecraft.banner.triangles_bottom.orange": "Сарғыш кертік асты",
  "block.minecraft.banner.triangles_bottom.pink": "Қызғылт кертік асты",
  "block.minecraft.banner.triangles_bottom.purple": "Күлгін кертік асты",
  "block.minecraft.banner.triangles_bottom.red": "Қызыл кертік асты",
  "block.minecraft.banner.triangles_bottom.white": "Ақ кертік асты",
  "block.minecraft.banner.triangles_bottom.yellow": "Сары кертік асты",
  "block.minecraft.banner.triangles_top.black": "Қара кертік үсті",
  "block.minecraft.banner.triangles_top.blue": "Көк кертік үсті",
  "block.minecraft.banner.triangles_top.brown": "Қоңыр кертік үсті",
  "block.minecraft.banner.triangles_top.cyan": "Көкзеңгір кертік үсті",
  "block.minecraft.banner.triangles_top.gray": "Сұр кертік үсті",
  "block.minecraft.banner.triangles_top.green": "Жасыл кертік үсті",
  "block.minecraft.banner.triangles_top.light_blue": "Көгілдір кертік үсті",
  "block.minecraft.banner.triangles_top.light_gray": "Боз кертік үсті",
  "block.minecraft.banner.triangles_top.lime": "Көкжасыл кертік үсті",
  "block.minecraft.banner.triangles_top.magenta": "Қызылкүрең кертік үсті",
  "block.minecraft.banner.triangles_top.orange": "Сарғыш кертік үсті",
  "block.minecraft.banner.triangles_top.pink": "Қызғылт кертік үсті",
  "block.minecraft.banner.triangles_top.purple": "Күлгін кертік үсті",
  "block.minecraft.banner.triangles_top.red": "Қызыл кертік үсті",
  "block.minecraft.banner.triangles_top.white": "Ақ кертік үсті",
  "block.minecraft.banner.triangles_top.yellow": "Сары кертік үсті",
  "block.minecraft.barrel": "Бөшке",
  "block.minecraft.barrier": "Тосқауыл",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Шамшырақ",
  "block.minecraft.beacon.primary": "Бастапқы күші",
  "block.minecraft.beacon.secondary": "Екінші күші",
  "block.minecraft.bed.no_sleep": "Түнде немесе дауыл кезінде ғана ұйықтай аласыз",
  "block.minecraft.bed.not_safe": "Жата алмайсың: төңіректе құбыжық жүр",
  "block.minecraft.bed.obstructed": "Бұл төсек бұғатталған",
  "block.minecraft.bed.occupied": "Бұл төсек бос емес",
  "block.minecraft.bed.too_far_away": "Жата алмайсыз: төсек тым алыс",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Ара ұясы",
  "block.minecraft.beehive": "Омарта",
  "block.minecraft.beetroots": "Қызылша",
  "block.minecraft.bell": "Қоңырау",
  "block.minecraft.big_dripleaf": "Үлкен тамшыжапырақ",
  "block.minecraft.big_dripleaf_stem": "Үлкен тамшыжапырақ сабағы",
  "block.minecraft.birch_button": "Қайың түйме",
  "block.minecraft.birch_door": "Қайың есік",
  "block.minecraft.birch_fence": "Қайың шарбақ",
  "block.minecraft.birch_fence_gate": "Қайың қақпа",
  "block.minecraft.birch_hanging_sign": "Аспалы қайың маңдайша",
  "block.minecraft.birch_leaves": "Қайың жапырағы",
  "block.minecraft.birch_log": "Қайың діңгегі",
  "block.minecraft.birch_planks": "Қайың тақтай",
  "block.minecraft.birch_pressure_plate": "Қайың басқыш",
  "block.minecraft.birch_sapling": "Қайың көшеті",
  "block.minecraft.birch_shelf": "Қайың сөре",
  "block.minecraft.birch_sign": "Қайың маңдайша",
  "block.minecraft.birch_slab": "Қайың тақта",
  "block.minecraft.birch_stairs": "Қайың тепкішек",
  "block.minecraft.birch_trapdoor": "Қайың қақпақ",
  "block.minecraft.birch_wall_hanging_sign": "Дуалдағы аспалы қайың маңдайша",
  "block.minecraft.birch_wall_sign": "Дуалдағы қайың маңдайша",
  "block.minecraft.birch_wood": "Қайың ағашы",
  "block.minecraft.black_banner": "Қара байрақ",
  "block.minecraft.black_bed": "Қара төсек",
  "block.minecraft.black_candle": "Қара майшам",
  "block.minecraft.black_candle_cake": "Қара майшамды торт",
  "block.minecraft.black_carpet": "Қара кілем",
  "block.minecraft.black_concrete": "Қара бетон",
  "block.minecraft.black_concrete_powder": "Қара құрғақ бетон",
  "block.minecraft.black_glazed_terracotta": "Қара зерлі қыш",
  "block.minecraft.black_shulker_box": "Қара шалкер жәшігі",
  "block.minecraft.black_stained_glass": "Қара шыны",
  "block.minecraft.black_stained_glass_pane": "Қара әйнек",
  "block.minecraft.black_terracotta": "Қара қыш",
  "block.minecraft.black_wool": "Қара жүн",
  "block.minecraft.blackstone": "Қаратас",
  "block.minecraft.blackstone_slab": "Қаратас тақта",
  "block.minecraft.blackstone_stairs": "Қаратас тепкішек",
  "block.minecraft.blackstone_wall": "Қаратас дуал",
  "block.minecraft.blast_furnace": "Балқытқыш",
  "block.minecraft.blue_banner": "Көк байрақ",
  "block.minecraft.blue_bed": "Көк төсек",
  "block.minecraft.blue_candle": "Көк майшам",
  "block.minecraft.blue_candle_cake": "Көк майшамды торт",
  "block.minecraft.blue_carpet": "Көк кілем",
  "block.minecraft.blue_concrete": "Көк бетон",
  "block.minecraft.blue_concrete_powder": "Көк құрғақ бетон",
  "block.minecraft.blue_glazed_terracotta": "Көк зерлі қыш",
  "block.minecraft.blue_ice": "Көк мұз",
  "block.minecraft.blue_orchid": "Көк сүйсін",
  "block.minecraft.blue_shulker_box": "Көк шалкер жәшігі",
  "block.minecraft.blue_stained_glass": "Көк шыны",
  "block.minecraft.blue_stained_glass_pane": "Көк әйнек",
  "block.minecraft.blue_terracotta": "Көк қыш",
  "block.minecraft.blue_wool": "Көк жүн",
  "block.minecraft.bone_block": "Сүйек блогі",
  "block.minecraft.bookshelf": "Кітап сөресі",
  "block.minecraft.brain_coral": "Ми маржан",
  "block.minecraft.brain_coral_block": "Ми маржан блогі",
  "block.minecraft.brain_coral_fan": "Желпуіш ми маржан",
  "block.minecraft.brain_coral_wall_fan": "Дуалдағы желпуіш ми маржаны",
  "block.minecraft.brewing_stand": "Демдегіш",
  "block.minecraft.brick_slab": "Кірпіш тақта",
  "block.minecraft.brick_stairs": "Кірпіш тепкішек",
  "block.minecraft.brick_wall": "Кірпіш дуал",
  "block.minecraft.bricks": "Кірпіш",
  "block.minecraft.brown_banner": "Қоңыр байрақ",
  "block.minecraft.brown_bed": "Қоңыр төсек",
  "block.minecraft.brown_candle": "Қоңыр майшам",
  "block.minecraft.brown_candle_cake": "Қоңыр майшамды торт",
  "block.minecraft.brown_carpet": "Қоңыр кілем",
  "block.minecraft.brown_concrete": "Қоңыр бетон",
  "block.minecraft.brown_concrete_powder": "Қоңыр құрғақ бетон",
  "block.minecraft.brown_glazed_terracotta": "Қоңыр зерлі қыш",
  "block.minecraft.brown_mushroom": "Қоңыр саңырауқұлақ",
  "block.minecraft.brown_mushroom_block": "Қоңыр саңырауқұлақ блогі",
  "block.minecraft.brown_shulker_box": "Қоңыр шалкер жәшігі",
  "block.minecraft.brown_stained_glass": "Қоңыр шыны",
  "block.minecraft.brown_stained_glass_pane": "Қоңыр әйнек",
  "block.minecraft.brown_terracotta": "Қоңыр қыш",
  "block.minecraft.brown_wool": "Қоңыр жүн",
  "block.minecraft.bubble_column": "Көпіршік бағанасы",
  "block.minecraft.bubble_coral": "Көпіршік маржан",
  "block.minecraft.bubble_coral_block": "Көпіршік маржан блогі",
  "block.minecraft.bubble_coral_fan": "Желпуіш көпіршік маржан",
  "block.minecraft.bubble_coral_wall_fan": "Дуалдағы желпуіш көпіршік маржаны",
  "block.minecraft.budding_amethyst": "Бүршіктенгіш аметист",
  "block.minecraft.bush": "Бұта",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактус гүлі",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Теңшелген сезгір скалк",
  "block.minecraft.campfire": "Ошақ",
  "block.minecraft.candle": "Майшам",
  "block.minecraft.candle_cake": "Майшамды торт",
  "block.minecraft.carrots": "Сәбіз",
  "block.minecraft.cartography_table": "Карташы үстелі",
  "block.minecraft.carved_pumpkin": "Ойылған асқабақ",
  "block.minecraft.cauldron": "Қазан",
  "block.minecraft.cave_air": "Үңгір ауасы",
  "block.minecraft.cave_vines": "Үңгір шырмауығы",
  "block.minecraft.cave_vines_plant": "Үңгір шырмауығының сабағы",
  "block.minecraft.chain": "Шынжыр",
  "block.minecraft.chain_command_block": "Тізбектік пәрмен блогі",
  "block.minecraft.cherry_button": "Шие түйме",
  "block.minecraft.cherry_door": "Шие есік",
  "block.minecraft.cherry_fence": "Шие шарбақ",
  "block.minecraft.cherry_fence_gate": "Шие қақпа",
  "block.minecraft.cherry_hanging_sign": "Аспалы шие маңдайша",
  "block.minecraft.cherry_leaves": "Шие жапырағы",
  "block.minecraft.cherry_log": "Шие діңгегі",
  "block.minecraft.cherry_planks": "Шие тақтай",
  "block.minecraft.cherry_pressure_plate": "Шие басқыш",
  "block.minecraft.cherry_sapling": "Шие көшеті",
  "block.minecraft.cherry_shelf": "Шие сөре",
  "block.minecraft.cherry_sign": "Шие маңдайша",
  "block.minecraft.cherry_slab": "Шие тақта",
  "block.minecraft.cherry_stairs": "Шие тепкішек",
  "block.minecraft.cherry_trapdoor": "Шие қақпақ",
  "block.minecraft.cherry_wall_hanging_sign": "Дуалдағы аспалы шие маңдайшасы",
  "block.minecraft.cherry_wall_sign": "Дуалдағы шие маңдайшасы",
  "block.minecraft.cherry_wood": "Шие ағашы",
  "block.minecraft.chest": "Сандық",
  "block.minecraft.chipped_anvil": "Шытынақ төс",
  "block.minecraft.chiseled_bookshelf": "Оюлы кітап сөресі",
  "block.minecraft.chiseled_copper": "Оюлы мыс",
  "block.minecraft.chiseled_deepslate": "Оюлы қатпартас",
  "block.minecraft.chiseled_nether_bricks": "Оюлы Незер кірпіші",
  "block.minecraft.chiseled_polished_blackstone": "Оюлы жылтыр қаратас",
  "block.minecraft.chiseled_quartz_block": "Оюлы шынытас блок",
  "block.minecraft.chiseled_red_sandstone": "Оюлы қызыл құмтас",
  "block.minecraft.chiseled_resin_bricks": "Оюлы шайыр кірпіш",
  "block.minecraft.chiseled_sandstone": "Оюлы құмтас",
  "block.minecraft.chiseled_stone_bricks": "Оюлы тас кірпіш",
  "block.minecraft.chiseled_tuff": "Оюлы туф",
  "block.minecraft.chiseled_tuff_bricks": "Оюлы туф кірпіш",
  "block.minecraft.chorus_flower": "Хорус гүлі",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Саз",
  "block.minecraft.closed_eyeblossom": "Жабық гүлжанар",
  "block.minecraft.coal_block": "Көмір блок",
  "block.minecraft.coal_ore": "Көмір кені",
  "block.minecraft.coarse_dirt": "Тастақ",
  "block.minecraft.cobbled_deepslate": "Жұмыр қатпартас",
  "block.minecraft.cobbled_deepslate_slab": "Жұмыр қатпартас тақта",
  "block.minecraft.cobbled_deepslate_stairs": "Жұмыр қатпартас тепкішек",
  "block.minecraft.cobbled_deepslate_wall": "Жұмыр қатпартас дуал",
  "block.minecraft.cobblestone": "Жұмыртас",
  "block.minecraft.cobblestone_slab": "Жұмыртас тақта",
  "block.minecraft.cobblestone_stairs": "Жұмыртас тепкішек",
  "block.minecraft.cobblestone_wall": "Жұмыртас дуал",
  "block.minecraft.cobweb": "Өрмек",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Пәрмен блогі",
  "block.minecraft.comparator": "Редстоун салыстырғыш",
  "block.minecraft.composter": "Қордаша",
  "block.minecraft.conduit": "Арна",
  "block.minecraft.copper_bars": "Мыс шыбық",
  "block.minecraft.copper_block": "Мыс блок",
  "block.minecraft.copper_bulb": "Мыс шам",
  "block.minecraft.copper_chain": "Мыс шынжыр",
  "block.minecraft.copper_chest": "Мыс сандық",
  "block.minecraft.copper_door": "Мыс есік",
  "block.minecraft.copper_golem_statue": "Мыс големінің мүсіні",
  "block.minecraft.copper_grate": "Мыс тор",
  "block.minecraft.copper_lantern": "Мыс шам",
  "block.minecraft.copper_ore": "Мыс кені",
  "block.minecraft.copper_torch": "Мыс шырақ",
  "block.minecraft.copper_trapdoor": "Мыс қақпақ",
  "block.minecraft.copper_wall_torch": "Дуалдағы мыс шырақ",
  "block.minecraft.cornflower": "Көк кекіре",
  "block.minecraft.cracked_deepslate_bricks": "Шытынақ қатпартас кірпіш",
  "block.minecraft.cracked_deepslate_tiles": "Шытынақ қатпартас тақташа",
  "block.minecraft.cracked_nether_bricks": "Шытынақ Незер кірпіші",
  "block.minecraft.cracked_polished_blackstone_bricks": "Шытынақ жылтыр қаратас кірпіш",
  "block.minecraft.cracked_stone_bricks": "Шытынақ тас кірпіш",
  "block.minecraft.crafter": "Жасауыр",
  "block.minecraft.crafting_table": "Шеберүстел",
  "block.minecraft.creaking_heart": "Қытыр жүрек",
  "block.minecraft.creeper_head": "Крипер басы",
  "block.minecraft.creeper_wall_head": "Дуалдағы крипер басы",
  "block.minecraft.crimson_button": "Қырмызы түйме",
  "block.minecraft.crimson_door": "Қырмызы есік",
  "block.minecraft.crimson_fence": "Қырмызы шарбақ",
  "block.minecraft.crimson_fence_gate": "Қырмызы қақпа",
  "block.minecraft.crimson_fungus": "Қырмызы арамқұлақ",
  "block.minecraft.crimson_hanging_sign": "Аспалы қырмызы маңдайша",
  "block.minecraft.crimson_hyphae": "Қырмызы гифа",
  "block.minecraft.crimson_nylium": "Қырмызы нилий",
  "block.minecraft.crimson_planks": "Қырмызы тақтай",
  "block.minecraft.crimson_pressure_plate": "Қырмызы басқыш",
  "block.minecraft.crimson_roots": "Қырмызы тамыр",
  "block.minecraft.crimson_shelf": "Қырмызы сөре",
  "block.minecraft.crimson_sign": "Қырмызы маңдайша",
  "block.minecraft.crimson_slab": "Қырмызы тақта",
  "block.minecraft.crimson_stairs": "Қырмызы тепкішек",
  "block.minecraft.crimson_stem": "Қырмызы сабақ",
  "block.minecraft.crimson_trapdoor": "Қырмызы қақпақ",
  "block.minecraft.crimson_wall_hanging_sign": "Дуалдағы аспалы қырмызы маңдайша",
  "block.minecraft.crimson_wall_sign": "Дуалдағы қырмызы маңдайша",
  "block.minecraft.crying_obsidian": "Жылауық обсидиан",
  "block.minecraft.cut_copper": "Қырлы мыс",
  "block.minecraft.cut_copper_slab": "Қырлы мыс тақта",
  "block.minecraft.cut_copper_stairs": "Қырлы мыс тепкішек",
  "block.minecraft.cut_red_sandstone": "Қырлы қызыл құмтас",
  "block.minecraft.cut_red_sandstone_slab": "Қырлы қызыл құмтас тақта",
  "block.minecraft.cut_sandstone": "Қырлы құмтас",
  "block.minecraft.cut_sandstone_slab": "Қырлы құмтас тақта",
  "block.minecraft.cyan_banner": "Көкзеңгір байрақ",
  "block.minecraft.cyan_bed": "Көкзеңгір төсек",
  "block.minecraft.cyan_candle": "Көкзеңгір майшам",
  "block.minecraft.cyan_candle_cake": "Көкзеңгір майшамды торт",
  "block.minecraft.cyan_carpet": "Көкзеңгір кілем",
  "block.minecraft.cyan_concrete": "Көкзеңгір бетон",
  "block.minecraft.cyan_concrete_powder": "Көкзеңгір құрғақ бетон",
  "block.minecraft.cyan_glazed_terracotta": "Көкзеңгір зерлі қыш",
  "block.minecraft.cyan_shulker_box": "Көкзеңгір шалкер жәшігі",
  "block.minecraft.cyan_stained_glass": "Көкзеңгір шыны",
  "block.minecraft.cyan_stained_glass_pane": "Көкзеңгір әйнек",
  "block.minecraft.cyan_terracotta": "Көкзеңгір қыш",
  "block.minecraft.cyan_wool": "Көкзеңгір жүн",
  "block.minecraft.damaged_anvil": "Сынық төс",
  "block.minecraft.dandelion": "Бақбақ",
  "block.minecraft.dark_oak_button": "Қара емен түйме",
  "block.minecraft.dark_oak_door": "Қара емен есік",
  "block.minecraft.dark_oak_fence": "Қара емен шарбақ",
  "block.minecraft.dark_oak_fence_gate": "Қара емен қақпа",
  "block.minecraft.dark_oak_hanging_sign": "Аспалы қара емен маңдайша",
  "block.minecraft.dark_oak_leaves": "Қара емен жапырағы",
  "block.minecraft.dark_oak_log": "Қара емен діңгегі",
  "block.minecraft.dark_oak_planks": "Қара емен тақтай",
  "block.minecraft.dark_oak_pressure_plate": "Қара емен басқыш",
  "block.minecraft.dark_oak_sapling": "Қара емен көшеті",
  "block.minecraft.dark_oak_shelf": "Қара емен сөре",
  "block.minecraft.dark_oak_sign": "Қара емен маңдайша",
  "block.minecraft.dark_oak_slab": "Қара емен тақта",
  "block.minecraft.dark_oak_stairs": "Қара емен тепкішек",
  "block.minecraft.dark_oak_trapdoor": "Қара емен қақпақ",
  "block.minecraft.dark_oak_wall_hanging_sign": "Дуалдағы аспалы қара емен маңдайша",
  "block.minecraft.dark_oak_wall_sign": "Дуалдағы қара емен маңдайша",
  "block.minecraft.dark_oak_wood": "Қара емен",
  "block.minecraft.dark_prismarine": "Қара призмарин",
  "block.minecraft.dark_prismarine_slab": "Қара призмарин тақта",
  "block.minecraft.dark_prismarine_stairs": "Қара призмарин тепкішек",
  "block.minecraft.daylight_detector": "Күн детекторы",
  "block.minecraft.dead_brain_coral": "Өлі ми маржан",
  "block.minecraft.dead_brain_coral_block": "Өлі ми маржан блогі",
  "block.minecraft.dead_brain_coral_fan": "Өлі желпуіш ми маржан",
  "block.minecraft.dead_brain_coral_wall_fan": "Дуалдағы өлі желпуіш ми маржаны",
  "block.minecraft.dead_bubble_coral": "Өлі көпіршік маржан",
  "block.minecraft.dead_bubble_coral_block": "Өлі көпіршік маржан блогі",
  "block.minecraft.dead_bubble_coral_fan": "Өлі желпуіш көпіршік маржан",
  "block.minecraft.dead_bubble_coral_wall_fan": "Дуалдағы өлі желпуіш көпіршік маржаны",
  "block.minecraft.dead_bush": "Өлі бұта",
  "block.minecraft.dead_fire_coral": "Өлі от маржан",
  "block.minecraft.dead_fire_coral_block": "Өлі от маржан блогі",
  "block.minecraft.dead_fire_coral_fan": "Өлі желпуіш от маржан",
  "block.minecraft.dead_fire_coral_wall_fan": "Дуалдағы өлі желпуіш от‐маржаны",
  "block.minecraft.dead_horn_coral": "Өлі мүйіз маржан",
  "block.minecraft.dead_horn_coral_block": "Өлі мүйіз маржан блогі",
  "block.minecraft.dead_horn_coral_fan": "Өлі желпуіш мүйіз маржан",
  "block.minecraft.dead_horn_coral_wall_fan": "Дуалдағы өлі желпуіш мүйіз маржаны",
  "block.minecraft.dead_tube_coral": "Өлі түтік маржан",
  "block.minecraft.dead_tube_coral_block": "Өлі түтік маржан блогі",
  "block.minecraft.dead_tube_coral_fan": "Өлі желпуіш түтік маржан",
  "block.minecraft.dead_tube_coral_wall_fan": "Дуалдағы өлі желпуіш түтік маржаны",
  "block.minecraft.decorated_pot": "Өрнекті құмыра",
  "block.minecraft.deepslate": "Қатпартас",
  "block.minecraft.deepslate_brick_slab": "Кірпіш қатпартас тақта",
  "block.minecraft.deepslate_brick_stairs": "Кірпіш қатпартас тепкішек",
  "block.minecraft.deepslate_brick_wall": "Кірпіш қатпартас дуал",
  "block.minecraft.deepslate_bricks": "Кірпіш қатпартас",
  "block.minecraft.deepslate_coal_ore": "Көмір кенді қатпартас",
  "block.minecraft.deepslate_copper_ore": "Мыс кенді қатпартас",
  "block.minecraft.deepslate_diamond_ore": "Алмас кенді қатпартас",
  "block.minecraft.deepslate_emerald_ore": "Замартас кенді қатпартас",
  "block.minecraft.deepslate_gold_ore": "Алтын кенді қатпартас",
  "block.minecraft.deepslate_iron_ore": "Темір кенді қатпартас",
  "block.minecraft.deepslate_lapis_ore": "Лазурит кенді қатпартас",
  "block.minecraft.deepslate_redstone_ore": "Редстоун кенді қатпартас",
  "block.minecraft.deepslate_tile_slab": "Тақтаташа қатпартас тақта",
  "block.minecraft.deepslate_tile_stairs": "Тақташа қатпартас тепкішек",
  "block.minecraft.deepslate_tile_wall": "Тақташа қатпартас дуал",
  "block.minecraft.deepslate_tiles": "Тақташа қатпартас",
  "block.minecraft.detector_rail": "Детектор теміржол",
  "block.minecraft.diamond_block": "Алмас блок",
  "block.minecraft.diamond_ore": "Алмас кені",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диорит тақта",
  "block.minecraft.diorite_stairs": "Диорит тепкішек",
  "block.minecraft.diorite_wall": "Диорит дуал",
  "block.minecraft.dirt": "Топырақ",
  "block.minecraft.dirt_path": "Cоқпақ",
  "block.minecraft.dispenser": "Таратқыш",
  "block.minecraft.dragon_egg": "Айдаһар жұмыртқасы",
  "block.minecraft.dragon_head": "Айдаһар басы",
  "block.minecraft.dragon_wall_head": "Айдаһар қабырға басы",
  "block.minecraft.dried_ghast": "Құрғақ гәст",
  "block.minecraft.dried_kelp_block": "Кепкен ламинария блогі",
  "block.minecraft.dripstone_block": "Спелеотем",
  "block.minecraft.dropper": "Тастауыр",
  "block.minecraft.emerald_block": "Замартас блок",
  "block.minecraft.emerald_ore": "Замартас кені",
  "block.minecraft.enchanting_table": "Дуагер үстелі",
  "block.minecraft.end_gateway": "Енд өткелі",
  "block.minecraft.end_portal": "Енд порталы",
  "block.minecraft.end_portal_frame": "Енд портал жақтауы",
  "block.minecraft.end_rod": "Енд сырығы",
  "block.minecraft.end_stone": "Ендертас",
  "block.minecraft.end_stone_brick_slab": "Ендертас кірпіш тақта",
  "block.minecraft.end_stone_brick_stairs": "Ендертас кірпіш тепкішек",
  "block.minecraft.end_stone_brick_wall": "Ендертас кірпіш дуал",
  "block.minecraft.end_stone_bricks": "Ендертас кірпіш",
  "block.minecraft.ender_chest": "Ендер сандық",
  "block.minecraft.exposed_chiseled_copper": "Тозық оюлы мыс",
  "block.minecraft.exposed_copper": "Тозық мыс",
  "block.minecraft.exposed_copper_bars": "Тозық мыс шыбық",
  "block.minecraft.exposed_copper_bulb": "Тозық мыс шам",
  "block.minecraft.exposed_copper_chain": "Тозық мыс шынжыр",
  "block.minecraft.exposed_copper_chest": "Тозық мыс сандық",
  "block.minecraft.exposed_copper_door": "Тозық мыс есік",
  "block.minecraft.exposed_copper_golem_statue": "Тозық мыс големнің мүсіні",
  "block.minecraft.exposed_copper_grate": "Тозық мыс тор",
  "block.minecraft.exposed_copper_lantern": "Тозық мыс шам",
  "block.minecraft.exposed_copper_trapdoor": "Тозық мыс қақпақ",
  "block.minecraft.exposed_cut_copper": "Тозық қырлы мыс",
  "block.minecraft.exposed_cut_copper_slab": "Тозық қырлы мыс тақта",
  "block.minecraft.exposed_cut_copper_stairs": "Тозық қырлы мыс тепкішек",
  "block.minecraft.exposed_lightning_rod": "Тозық жайтартқыш",
  "block.minecraft.farmland": "Егіс",
  "block.minecraft.fern": "Қырыққұлақ",
  "block.minecraft.fire": "От",
  "block.minecraft.fire_coral": "От маржан",
  "block.minecraft.fire_coral_block": "От маржан блогі",
  "block.minecraft.fire_coral_fan": "Желпуіш от маржан",
  "block.minecraft.fire_coral_wall_fan": "Желпуіш от қабырға маржаны",
  "block.minecraft.firefly_bush": "Жарқырауық бұтасы",
  "block.minecraft.fletching_table": "Оқшы үстелі",
  "block.minecraft.flower_pot": "Гүл құмырасы",
  "block.minecraft.flowering_azalea": "Гүлдеген азалия",
  "block.minecraft.flowering_azalea_leaves": "Гүлдеген азалия жапырағы",
  "block.minecraft.frogspawn": "Бақа уылдырығы",
  "block.minecraft.frosted_ice": "Еріген мұз",
  "block.minecraft.furnace": "Пеш",
  "block.minecraft.gilded_blackstone": "Алтын жалатқан қаратас",
  "block.minecraft.glass": "Шыны",
  "block.minecraft.glass_pane": "Әйнек",
  "block.minecraft.glow_lichen": "Жарқырауық қына",
  "block.minecraft.glowstone": "Жарықтас",
  "block.minecraft.gold_block": "Алтын блок",
  "block.minecraft.gold_ore": "Алтын кені",
  "block.minecraft.golden_dandelion": "Алтын бақбақ",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранит тақта",
  "block.minecraft.granite_stairs": "Гранит тепкішек",
  "block.minecraft.granite_wall": "Гранит дуал",
  "block.minecraft.grass": "Шөп",
  "block.minecraft.grass_block": "Шым",
  "block.minecraft.gravel": "Қиыршықтас",
  "block.minecraft.gray_banner": "Сұр байрақ",
  "block.minecraft.gray_bed": "Сұр төсек",
  "block.minecraft.gray_candle": "Сұр майшам",
  "block.minecraft.gray_candle_cake": "Сұр майшамды торт",
  "block.minecraft.gray_carpet": "Сұр кілем",
  "block.minecraft.gray_concrete": "Сұр бетон",
  "block.minecraft.gray_concrete_powder": "Сұр құрғақ бетон",
  "block.minecraft.gray_glazed_terracotta": "Сұр зерлі қыш",
  "block.minecraft.gray_shulker_box": "Сұр шалкер жәшігі",
  "block.minecraft.gray_stained_glass": "Сұр шыны",
  "block.minecraft.gray_stained_glass_pane": "Сұр әйнек",
  "block.minecraft.gray_terracotta": "Сұр қыш",
  "block.minecraft.gray_wool": "Сұр жүн",
  "block.minecraft.green_banner": "Жасыл байрақ",
  "block.minecraft.green_bed": "Жасыл төсек",
  "block.minecraft.green_candle": "Жасыл майшам",
  "block.minecraft.green_candle_cake": "Жасыл майшамды торт",
  "block.minecraft.green_carpet": "Жасыл кілем",
  "block.minecraft.green_concrete": "Жасыл бетон",
  "block.minecraft.green_concrete_powder": "Жасыл құрғақ бетон",
  "block.minecraft.green_glazed_terracotta": "Жасыл зерлі қыш",
  "block.minecraft.green_shulker_box": "Жасыл шалкер жәшігі",
  "block.minecraft.green_stained_glass": "Жасыл шыны",
  "block.minecraft.green_stained_glass_pane": "Жасыл әйнек",
  "block.minecraft.green_terracotta": "Жасыл қыш",
  "block.minecraft.green_wool": "Жасыл жүн",
  "block.minecraft.grindstone": "Қайрақ",
  "block.minecraft.hanging_roots": "Салбыр тамыр",
  "block.minecraft.hay_block": "Бау пішен",
  "block.minecraft.heavy_core": "Ауыр өзек",
  "block.minecraft.heavy_weighted_pressure_plate": "Ауыр басқыш",
  "block.minecraft.honey_block": "Бал блок",
  "block.minecraft.honeycomb_block": "Кәрез блогі",
  "block.minecraft.hopper": "Құйғыш",
  "block.minecraft.horn_coral": "Мүйіз маржан",
  "block.minecraft.horn_coral_block": "Мүйіз маржан блогі",
  "block.minecraft.horn_coral_fan": "Желпуіш мүйіз маржан",
  "block.minecraft.horn_coral_wall_fan": "Дуалдағы желпуіш мүйіз маржаны",
  "block.minecraft.ice": "Мұз",
  "block.minecraft.infested_chiseled_stone_bricks": "Жұқпалы оюлы тас кірпіш",
  "block.minecraft.infested_cobblestone": "Жұқпалы жұмыртас",
  "block.minecraft.infested_cracked_stone_bricks": "Жұқпалы шытынақ тас кірпіш",
  "block.minecraft.infested_deepslate": "Жұқпалы қатпартас",
  "block.minecraft.infested_mossy_stone_bricks": "Жұқпалы мүкті тас кірпіш",
  "block.minecraft.infested_stone": "Жұқпалы тас",
  "block.minecraft.infested_stone_bricks": "Жұқпалы тас кірпіш",
  "block.minecraft.iron_bars": "Темір шыбық",
  "block.minecraft.iron_block": "Темір блок",
  "block.minecraft.iron_chain": "Темір шынжыр",
  "block.minecraft.iron_door": "Темір есік",
  "block.minecraft.iron_ore": "Темір кені",
  "block.minecraft.iron_trapdoor": "Темір қақпақ",
  "block.minecraft.jack_o_lantern": "Жәк шамы",
  "block.minecraft.jigsaw": "Пазл блогі",
  "block.minecraft.jukebox": "Күйсандық",
  "block.minecraft.jungle_button": "Джунгли түймесі",
  "block.minecraft.jungle_door": "Джунгли есігі",
  "block.minecraft.jungle_fence": "Джунгли шарбағы",
  "block.minecraft.jungle_fence_gate": "Джунгли қақпасы",
  "block.minecraft.jungle_hanging_sign": "Аспалы джунгли маңдайшасы",
  "block.minecraft.jungle_leaves": "Джунгли жапырағы",
  "block.minecraft.jungle_log": "Джунгли діңгегі",
  "block.minecraft.jungle_planks": "Джунгли тақтайы",
  "block.minecraft.jungle_pressure_plate": "Джунгли басқышы",
  "block.minecraft.jungle_sapling": "Джунгли көшеті",
  "block.minecraft.jungle_shelf": "Тропик сөре",
  "block.minecraft.jungle_sign": "Джунгли маңдайшасы",
  "block.minecraft.jungle_slab": "Джунгли тақтасы",
  "block.minecraft.jungle_stairs": "Джунгли тепкішегі",
  "block.minecraft.jungle_trapdoor": "Джунгли қақпағы",
  "block.minecraft.jungle_wall_hanging_sign": "Дуалдағы аспалы джунгли маңдайшасы",
  "block.minecraft.jungle_wall_sign": "Дуалдағы джунгли маңдайшасы",
  "block.minecraft.jungle_wood": "Джунгли ағашы",
  "block.minecraft.kelp": "Ламинария",
  "block.minecraft.kelp_plant": "Ламинария сабағы",
  "block.minecraft.ladder": "Саты",
  "block.minecraft.lantern": "Шамдал",
  "block.minecraft.lapis_block": "Лазурит блок",
  "block.minecraft.lapis_ore": "Лазурит кені",
  "block.minecraft.large_amethyst_bud": "Үлкен аметист бүршігі",
  "block.minecraft.large_fern": "Үлкен қырыққұлақ",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Қазандағы лава",
  "block.minecraft.leaf_litter": "Түскен жапырақ",
  "block.minecraft.lectern": "Мінбе",
  "block.minecraft.lever": "Иінтірек",
  "block.minecraft.light": "Жарық",
  "block.minecraft.light_blue_banner": "Көгілдір байрақ",
  "block.minecraft.light_blue_bed": "Көгілдір төсек",
  "block.minecraft.light_blue_candle": "Көгілдір майшам",
  "block.minecraft.light_blue_candle_cake": "Көгілдір майшамды торт",
  "block.minecraft.light_blue_carpet": "Көгілдір кілем",
  "block.minecraft.light_blue_concrete": "Көгілдір бетон",
  "block.minecraft.light_blue_concrete_powder": "Көгілдір құрғақ бетон",
  "block.minecraft.light_blue_glazed_terracotta": "Көгілдір зерлі қыш",
  "block.minecraft.light_blue_shulker_box": "Көгілдір шалкер жәшігі",
  "block.minecraft.light_blue_stained_glass": "Көгілдір шыны",
  "block.minecraft.light_blue_stained_glass_pane": "Көгілдір әйнек",
  "block.minecraft.light_blue_terracotta": "Көгілдір қыш",
  "block.minecraft.light_blue_wool": "Көгілдір жүн",
  "block.minecraft.light_gray_banner": "Боз байрақ",
  "block.minecraft.light_gray_bed": "Боз төсек",
  "block.minecraft.light_gray_candle": "Боз майшам",
  "block.minecraft.light_gray_candle_cake": "Боз майшамды торт",
  "block.minecraft.light_gray_carpet": "Боз кілем",
  "block.minecraft.light_gray_concrete": "Боз бетон",
  "block.minecraft.light_gray_concrete_powder": "Боз құрғақ бетон",
  "block.minecraft.light_gray_glazed_terracotta": "Боз зерлі қыш",
  "block.minecraft.light_gray_shulker_box": "Боз шалкер жәшігі",
  "block.minecraft.light_gray_stained_glass": "Боз шыны",
  "block.minecraft.light_gray_stained_glass_pane": "Боз әйнек",
  "block.minecraft.light_gray_terracotta": "Боз қыш",
  "block.minecraft.light_gray_wool": "Боз жүн",
  "block.minecraft.light_weighted_pressure_plate": "Жеңіл басқыш",
  "block.minecraft.lightning_rod": "Жайтартқыш",
  "block.minecraft.lilac": "Мамыргүл",
  "block.minecraft.lily_of_the_valley": "Меруертгүл",
  "block.minecraft.lily_pad": "Тұңғиық",
  "block.minecraft.lime_banner": "Көкжасыл байрақ",
  "block.minecraft.lime_bed": "Көкжасыл төсек",
  "block.minecraft.lime_candle": "Көкжасыл майшам",
  "block.minecraft.lime_candle_cake": "Көкжасыл майшамды торт",
  "block.minecraft.lime_carpet": "Көкжасыл кілем",
  "block.minecraft.lime_concrete": "Көкжасыл бетон",
  "block.minecraft.lime_concrete_powder": "Көкжасыл құрғақ бетон",
  "block.minecraft.lime_glazed_terracotta": "Көкжасыл зерлі қыш",
  "block.minecraft.lime_shulker_box": "Көкжасыл шалкер жәшігі",
  "block.minecraft.lime_stained_glass": "Көкжасыл шыны",
  "block.minecraft.lime_stained_glass_pane": "Көкжасыл әйнек",
  "block.minecraft.lime_terracotta": "Көкжасыл қыш",
  "block.minecraft.lime_wool": "Көкжасыл жүн",
  "block.minecraft.lodestone": "Бағдартас",
  "block.minecraft.loom": "Тоқыма білдек",
  "block.minecraft.magenta_banner": "Қызылкүрең байрақ",
  "block.minecraft.magenta_bed": "Қызылкүрең төсек",
  "block.minecraft.magenta_candle": "Қызылкүрең майшам",
  "block.minecraft.magenta_candle_cake": "Қызылкүрең майшамды торт",
  "block.minecraft.magenta_carpet": "Қызылкүрең кілем",
  "block.minecraft.magenta_concrete": "Қызылкүрең бетон",
  "block.minecraft.magenta_concrete_powder": "Қызылкүрең құрғақ бетон",
  "block.minecraft.magenta_glazed_terracotta": "Қызылкүрең зерлі қыш",
  "block.minecraft.magenta_shulker_box": "Қызылкүрең шалкер жәшігі",
  "block.minecraft.magenta_stained_glass": "Қызылкүрең шыны",
  "block.minecraft.magenta_stained_glass_pane": "Қызылкүрең әйнек",
  "block.minecraft.magenta_terracotta": "Қызылкүрең қыш",
  "block.minecraft.magenta_wool": "Қызылкүрең жүн",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Мангр түймесі",
  "block.minecraft.mangrove_door": "Мангр есігі",
  "block.minecraft.mangrove_fence": "Мангр шарбағы",
  "block.minecraft.mangrove_fence_gate": "Мангр қақпасы",
  "block.minecraft.mangrove_hanging_sign": "Аспалы мангр маңдайшасы",
  "block.minecraft.mangrove_leaves": "Мангр жапырағы",
  "block.minecraft.mangrove_log": "Мангр діңгегі",
  "block.minecraft.mangrove_planks": "Мангр тақтайы",
  "block.minecraft.mangrove_pressure_plate": "Мангр басқышы",
  "block.minecraft.mangrove_propagule": "Мангр қалемшесі",
  "block.minecraft.mangrove_roots": "Мангр тамыры",
  "block.minecraft.mangrove_shelf": "Мангр сөресі",
  "block.minecraft.mangrove_sign": "Мангр маңдайшасы",
  "block.minecraft.mangrove_slab": "Мангр тақтасы",
  "block.minecraft.mangrove_stairs": "Мангр тепкішегі",
  "block.minecraft.mangrove_trapdoor": "Мангр қақпағы",
  "block.minecraft.mangrove_wall_hanging_sign": "Дуалдағы аспалы мангр маңдайшасы",
  "block.minecraft.mangrove_wall_sign": "Дуалдағы мангр маңдайшасы",
  "block.minecraft.mangrove_wood": "Мангр ағашы",
  "block.minecraft.medium_amethyst_bud": "Орта аметист бүршігі",
  "block.minecraft.melon": "Қарбыз",
  "block.minecraft.melon_stem": "Қарбыз сабағы",
  "block.minecraft.moss_block": "Мүк блок",
  "block.minecraft.moss_carpet": "Мүк төсеніш",
  "block.minecraft.mossy_cobblestone": "Мүкті жұмыртас",
  "block.minecraft.mossy_cobblestone_slab": "Мүкті жұмыртас тақта",
  "block.minecraft.mossy_cobblestone_stairs": "Мүкті жұмыртас тепкішек",
  "block.minecraft.mossy_cobblestone_wall": "Мүкті жұмыртас дуал",
  "block.minecraft.mossy_stone_brick_slab": "Мүкті тас кірпіш тақта",
  "block.minecraft.mossy_stone_brick_stairs": "Мүкті тас кірпіш тепкішек",
  "block.minecraft.mossy_stone_brick_wall": "Мүкті тас кірпіш дуал",
  "block.minecraft.mossy_stone_bricks": "Мүкті тас кірпіш",
  "block.minecraft.moving_piston": "Қозғалған піспек",
  "block.minecraft.mud": "Балшық",
  "block.minecraft.mud_brick_slab": "Саман кірпіш тақта",
  "block.minecraft.mud_brick_stairs": "Саман кірпіш тепкішек",
  "block.minecraft.mud_brick_wall": "Саман кірпіш дуал",
  "block.minecraft.mud_bricks": "Саман кірпіш",
  "block.minecraft.muddy_mangrove_roots": "Лай‐лай мангр тамыры",
  "block.minecraft.mushroom_stem": "Саңырауқұлақ сабағы",
  "block.minecraft.mycelium": "Жіпшумақ",
  "block.minecraft.nether_brick_fence": "Незер кірпіш шарбағы",
  "block.minecraft.nether_brick_slab": "Незер кірпіш тақтасы",
  "block.minecraft.nether_brick_stairs": "Незер кірпіш тепкішегі",
  "block.minecraft.nether_brick_wall": "Незер кірпіш дуалы",
  "block.minecraft.nether_bricks": "Незер кірпіші",
  "block.minecraft.nether_gold_ore": "Алтын кенді незерәк",
  "block.minecraft.nether_portal": "Незер порталы",
  "block.minecraft.nether_quartz_ore": "Шынытас кенді незерәк",
  "block.minecraft.nether_sprouts": "Незер өскіні",
  "block.minecraft.nether_wart": "Незер безі",
  "block.minecraft.nether_wart_block": "Незер без блогі",
  "block.minecraft.netherite_block": "Незерит блок",
  "block.minecraft.netherrack": "Незерәк",
  "block.minecraft.note_block": "Нота блогі",
  "block.minecraft.oak_button": "Емен түйме",
  "block.minecraft.oak_door": "Емен есік",
  "block.minecraft.oak_fence": "Емен шарбақ",
  "block.minecraft.oak_fence_gate": "Емен қақпа",
  "block.minecraft.oak_hanging_sign": "Аспалы емен маңдайша",
  "block.minecraft.oak_leaves": "Емен жапырағы",
  "block.minecraft.oak_log": "Емен діңгегі",
  "block.minecraft.oak_planks": "Емен тақтай",
  "block.minecraft.oak_pressure_plate": "Емен басқыш",
  "block.minecraft.oak_sapling": "Емен көшеті",
  "block.minecraft.oak_shelf": "Емен сөре",
  "block.minecraft.oak_sign": "Емен маңдайша",
  "block.minecraft.oak_slab": "Емен тақта",
  "block.minecraft.oak_stairs": "Емен тепкішек",
  "block.minecraft.oak_trapdoor": "Емен қақпақ",
  "block.minecraft.oak_wall_hanging_sign": "Дуалдағы аспалы емен маңдайша",
  "block.minecraft.oak_wall_sign": "Дуаладғы емен маңдайша",
  "block.minecraft.oak_wood": "Емен ағашы",
  "block.minecraft.observer": "Қарауыр",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Жоса бақашам",
  "block.minecraft.ominous_banner": "Қатерлі байрақ",
  "block.minecraft.open_eyeblossom": "Ашық гүлжанар",
  "block.minecraft.orange_banner": "Сарғыш байрақ",
  "block.minecraft.orange_bed": "Сарғыш төсек",
  "block.minecraft.orange_candle": "Сарғыш майшам",
  "block.minecraft.orange_candle_cake": "Сарғыш майшамды торт",
  "block.minecraft.orange_carpet": "Сарғыш кілем",
  "block.minecraft.orange_concrete": "Сарғыш бетон",
  "block.minecraft.orange_concrete_powder": "Сарғыш құрғақ бетон",
  "block.minecraft.orange_glazed_terracotta": "Сарғыш зерлі қыш",
  "block.minecraft.orange_shulker_box": "Сарғыш шалкер жәшігі",
  "block.minecraft.orange_stained_glass": "Сарғыш шыны",
  "block.minecraft.orange_stained_glass_pane": "Сарғыш әйнек",
  "block.minecraft.orange_terracotta": "Сарғыш қыш",
  "block.minecraft.orange_tulip": "Сарғалдақ",
  "block.minecraft.orange_wool": "Сарғыш жүн",
  "block.minecraft.oxeye_daisy": "Түймедақ",
  "block.minecraft.oxidized_chiseled_copper": "Тотық оюлы мыс",
  "block.minecraft.oxidized_copper": "Тотық мыс",
  "block.minecraft.oxidized_copper_bars": "Тотық мыс шыбық",
  "block.minecraft.oxidized_copper_bulb": "Тотық мыс шам",
  "block.minecraft.oxidized_copper_chain": "Тотық мыс шынжыр",
  "block.minecraft.oxidized_copper_chest": "Тотық мыс сандық",
  "block.minecraft.oxidized_copper_door": "Тотық мыс қақпақ",
  "block.minecraft.oxidized_copper_golem_statue": "Тотық мыс големнің мүсіні",
  "block.minecraft.oxidized_copper_grate": "Тотық мыс тор",
  "block.minecraft.oxidized_copper_lantern": "Тотық мыс шам",
  "block.minecraft.oxidized_copper_trapdoor": "Тотық мыс қақпақ",
  "block.minecraft.oxidized_cut_copper": "Тотық қырлы мыс",
  "block.minecraft.oxidized_cut_copper_slab": "Тотық қырлы мыс тақта",
  "block.minecraft.oxidized_cut_copper_stairs": "Тотық қырлы мыс тепкішек",
  "block.minecraft.oxidized_lightning_rod": "Тотық жайтартқыш",
  "block.minecraft.packed_ice": "Қалың мұз",
  "block.minecraft.packed_mud": "Саман",
  "block.minecraft.pale_hanging_moss": "Қу жалбыр түк",
  "block.minecraft.pale_moss_block": "Қу түк блок",
  "block.minecraft.pale_moss_carpet": "Қу түк кілем",
  "block.minecraft.pale_oak_button": "Қу емен түйме",
  "block.minecraft.pale_oak_door": "Қу емен есік",
  "block.minecraft.pale_oak_fence": "Қу емен шарбақ",
  "block.minecraft.pale_oak_fence_gate": "Қу емен қақпа",
  "block.minecraft.pale_oak_hanging_sign": "Аспалы қу емен маңдайша",
  "block.minecraft.pale_oak_leaves": "Қу емен жапырағы",
  "block.minecraft.pale_oak_log": "Қу емен діңгегі",
  "block.minecraft.pale_oak_planks": "Қу емен тақтай",
  "block.minecraft.pale_oak_pressure_plate": "Қу емен басқыш",
  "block.minecraft.pale_oak_sapling": "Қу емен көшеті",
  "block.minecraft.pale_oak_shelf": "Қу емен сөре",
  "block.minecraft.pale_oak_sign": "Қу емен маңдайша",
  "block.minecraft.pale_oak_slab": "Қу емен тақта",
  "block.minecraft.pale_oak_stairs": "Қу емен тепкішек",
  "block.minecraft.pale_oak_trapdoor": "Қу емен қақпақ",
  "block.minecraft.pale_oak_wall_hanging_sign": "Дуалдағы аспалы қу емен маңдайша",
  "block.minecraft.pale_oak_wall_sign": "Дуалдағы қу емен маңдайша",
  "block.minecraft.pale_oak_wood": "Қу емен ағашы",
  "block.minecraft.pearlescent_froglight": "Седеп бақашам",
  "block.minecraft.peony": "Таушымылдық",
  "block.minecraft.petrified_oak_slab": "Тастай емен тақта",
  "block.minecraft.piglin_head": "Пиглин басы",
  "block.minecraft.piglin_wall_head": "Дуалдағы пиглин басы",
  "block.minecraft.pink_banner": "Қызғылт байрақ",
  "block.minecraft.pink_bed": "Қызғылт төсек",
  "block.minecraft.pink_candle": "Қызғылт майшам",
  "block.minecraft.pink_candle_cake": "Қызғылт майшамды торт",
  "block.minecraft.pink_carpet": "Қызғылт кілем",
  "block.minecraft.pink_concrete": "Қызғылт бетон",
  "block.minecraft.pink_concrete_powder": "Қызғылт құрғақ бетон",
  "block.minecraft.pink_glazed_terracotta": "Қызғылт зерлі қыш",
  "block.minecraft.pink_petals": "Қызғылт күлте",
  "block.minecraft.pink_shulker_box": "Қызғылт шалкер жәшігі",
  "block.minecraft.pink_stained_glass": "Қызғылт шыны",
  "block.minecraft.pink_stained_glass_pane": "Қызғылт әйнек",
  "block.minecraft.pink_terracotta": "Қызғылт қыш",
  "block.minecraft.pink_tulip": "Қызғалдақ",
  "block.minecraft.pink_wool": "Қызғылт жүн",
  "block.minecraft.piston": "Піспек",
  "block.minecraft.piston_head": "Піспек басы",
  "block.minecraft.pitcher_crop": "Құмангүл өскіні",
  "block.minecraft.pitcher_plant": "Құмангүл",
  "block.minecraft.player_head": "Ойыншы басы",
  "block.minecraft.player_head.named": "%s басы",
  "block.minecraft.player_wall_head": "Дуалдағы ойыншы басы",
  "block.minecraft.podzol": "Сортаң топырақ",
  "block.minecraft.pointed_dripstone": "Үшкір спелеотем",
  "block.minecraft.polished_andesite": "Жылтыр андезит",
  "block.minecraft.polished_andesite_slab": "Жылтыр андезит тақта",
  "block.minecraft.polished_andesite_stairs": "Жылтыр андезит тепкішек",
  "block.minecraft.polished_basalt": "Жылтыр базальт",
  "block.minecraft.polished_blackstone": "Жылтыр қаратас",
  "block.minecraft.polished_blackstone_brick_slab": "Жылтыр қаратас кірпіш тақта",
  "block.minecraft.polished_blackstone_brick_stairs": "Жылтыр қаратас кірпіш тепкішек",
  "block.minecraft.polished_blackstone_brick_wall": "Жылтыр қаратас кірпіш дуал",
  "block.minecraft.polished_blackstone_bricks": "Жылтыр қаратас кірпіш",
  "block.minecraft.polished_blackstone_button": "Жылтыр қаратас түйме",
  "block.minecraft.polished_blackstone_pressure_plate": "Жылтыр қаратас басқыш",
  "block.minecraft.polished_blackstone_slab": "Жылтыр қаратас тақта",
  "block.minecraft.polished_blackstone_stairs": "Жылтыр қаратас тепкішек",
  "block.minecraft.polished_blackstone_wall": "Жылтыр қаратас дуал",
  "block.minecraft.polished_deepslate": "Жылтыр қатпартас",
  "block.minecraft.polished_deepslate_slab": "Жылтыр қатпартас тақта",
  "block.minecraft.polished_deepslate_stairs": "Жылтыр қатпартас тепкішек",
  "block.minecraft.polished_deepslate_wall": "Жылтыр қатпартас дуал",
  "block.minecraft.polished_diorite": "Жылтыр диорит",
  "block.minecraft.polished_diorite_slab": "Жылтыр диорит тақта",
  "block.minecraft.polished_diorite_stairs": "Жылтыр диорит тепкішек",
  "block.minecraft.polished_granite": "Жылтыр гранит",
  "block.minecraft.polished_granite_slab": "Жылтыр гранит тақта",
  "block.minecraft.polished_granite_stairs": "Жылтыр гранит тепкішек",
  "block.minecraft.polished_tuff": "Жылтыр туф",
  "block.minecraft.polished_tuff_slab": "Жылтыр туф тақта",
  "block.minecraft.polished_tuff_stairs": "Жылтыр туф тепкішек",
  "block.minecraft.polished_tuff_wall": "Жылтыр туф дуал",
  "block.minecraft.poppy": "Көкнәр",
  "block.minecraft.potatoes": "Картоп",
  "block.minecraft.potted_acacia_sapling": "Құмырадағы акация көшеті",
  "block.minecraft.potted_allium": "Құмырадағы жуа",
  "block.minecraft.potted_azalea_bush": "Құмырадағы азалия",
  "block.minecraft.potted_azure_bluet": "Құмырадағы хаустония",
  "block.minecraft.potted_bamboo": "Құмырадағы бамбук",
  "block.minecraft.potted_birch_sapling": "Құмырадағы қайың көшеті",
  "block.minecraft.potted_blue_orchid": "Құмырадағы көк сүйсін",
  "block.minecraft.potted_brown_mushroom": "Құмырадағы қоңыр саңырауқұлақ",
  "block.minecraft.potted_cactus": "Құмырадағы кактус",
  "block.minecraft.potted_cherry_sapling": "Құмырадағы шие көшеті",
  "block.minecraft.potted_closed_eyeblossom": "Құмырадағы жабық гүлжанар",
  "block.minecraft.potted_cornflower": "Құмырадағы көк кекіре",
  "block.minecraft.potted_crimson_fungus": "Құмырадағы қырмызы арамқұлақ",
  "block.minecraft.potted_crimson_roots": "Құмырадағы қырмызы тамыр",
  "block.minecraft.potted_dandelion": "Құмырадағы бақбақ",
  "block.minecraft.potted_dark_oak_sapling": "Құмырадағы қара емен көшеті",
  "block.minecraft.potted_dead_bush": "Құмырадағы өлі бұта",
  "block.minecraft.potted_fern": "Құмырадағы қырыққұлақ",
  "block.minecraft.potted_flowering_azalea_bush": "Құмырадағы гүлдеген азалия",
  "block.minecraft.potted_golden_dandelion": "Құмырадағы алтын бақбақ",
  "block.minecraft.potted_jungle_sapling": "Құмырадағы джунгли көшеті",
  "block.minecraft.potted_lily_of_the_valley": "Құмырадағы меруертгүл",
  "block.minecraft.potted_mangrove_propagule": "Құмырадағы мангр қалемшесі",
  "block.minecraft.potted_oak_sapling": "Құмырадағы емен көшеті",
  "block.minecraft.potted_open_eyeblossom": "Құмырадағы ашық гүлжанар",
  "block.minecraft.potted_orange_tulip": "Құмырадағы сарғалдақ",
  "block.minecraft.potted_oxeye_daisy": "Құмырадағы түймедақ",
  "block.minecraft.potted_pale_oak_sapling": "Құмырадағы қу емен көшеті",
  "block.minecraft.potted_pink_tulip": "Құмырадағы қызғалдақ",
  "block.minecraft.potted_poppy": "Құмырадағы көкнәр",
  "block.minecraft.potted_red_mushroom": "Құмырадағы қызыл саңырауқұлақ",
  "block.minecraft.potted_red_tulip": "Құмырадағы қырғалдақ",
  "block.minecraft.potted_spruce_sapling": "Құмырадағы шырша көшеті",
  "block.minecraft.potted_torchflower": "Құмырадағы шырақгүл",
  "block.minecraft.potted_warped_fungus": "Құмырадағы теріс арамқұлақ",
  "block.minecraft.potted_warped_roots": "Құмырадағы теріс тамыр",
  "block.minecraft.potted_white_tulip": "Құмырадағы бозғалдақ",
  "block.minecraft.potted_wither_rose": "Құмырадағы Уизер раушаны",
  "block.minecraft.powder_snow": "Күпсек қар",
  "block.minecraft.powder_snow_cauldron": "Қазандағы күпсек қар",
  "block.minecraft.powered_rail": "Қуатты теміржол",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмарин кірпіш тақта",
  "block.minecraft.prismarine_brick_stairs": "Призмарин кірпіш тепкішек",
  "block.minecraft.prismarine_bricks": "Призмарин кірпіш",
  "block.minecraft.prismarine_slab": "Призмарин тақта",
  "block.minecraft.prismarine_stairs": "Призмарин тепкішек",
  "block.minecraft.prismarine_wall": "Призмарин дуал",
  "block.minecraft.pumpkin": "Асқабақ",
  "block.minecraft.pumpkin_stem": "Асқабақ сабағы",
  "block.minecraft.purple_banner": "Күлгін байрақ",
  "block.minecraft.purple_bed": "Күлгін төсек",
  "block.minecraft.purple_candle": "Күлгін майшам",
  "block.minecraft.purple_candle_cake": "Күлгін майшамды торт",
  "block.minecraft.purple_carpet": "Күлгін кілем",
  "block.minecraft.purple_concrete": "Күлгін бетон",
  "block.minecraft.purple_concrete_powder": "Күлгін құрғақ бетон",
  "block.minecraft.purple_glazed_terracotta": "Күлгін зерлі қыш",
  "block.minecraft.purple_shulker_box": "Күлгін шалкер жәшігі",
  "block.minecraft.purple_stained_glass": "Күлгін шыны",
  "block.minecraft.purple_stained_glass_pane": "Күлгін әйнек",
  "block.minecraft.purple_terracotta": "Күлгін қыш",
  "block.minecraft.purple_wool": "Күлгін жүн",
  "block.minecraft.purpur_block": "Пурпур",
  "block.minecraft.purpur_pillar": "Пурпур бағана",
  "block.minecraft.purpur_slab": "Пурпур тақта",
  "block.minecraft.purpur_stairs": "Пурпур тепкішек",
  "block.minecraft.quartz_block": "Шынытас блок",
  "block.minecraft.quartz_bricks": "Шынытас кірпіш",
  "block.minecraft.quartz_pillar": "Шынытас бағана",
  "block.minecraft.quartz_slab": "Шынытас тақта",
  "block.minecraft.quartz_stairs": "Шынытас тепкішек",
  "block.minecraft.rail": "Теміржол",
  "block.minecraft.raw_copper_block": "Шикі мыс блок",
  "block.minecraft.raw_gold_block": "Шикі алтын блок",
  "block.minecraft.raw_iron_block": "Шикі темір блок",
  "block.minecraft.red_banner": "Қызыл байрақ",
  "block.minecraft.red_bed": "Қызыл төсек",
  "block.minecraft.red_candle": "Қызыл майшам",
  "block.minecraft.red_candle_cake": "Қызыл майшамды торт",
  "block.minecraft.red_carpet": "Қызыл кілем",
  "block.minecraft.red_concrete": "Қызыл бетон",
  "block.minecraft.red_concrete_powder": "Қызыл құрғақ бетон",
  "block.minecraft.red_glazed_terracotta": "Қызыл зерлі қыш",
  "block.minecraft.red_mushroom": "Қызыл саңырауқұлақ",
  "block.minecraft.red_mushroom_block": "Қызыл саңырауқұлақ блогі",
  "block.minecraft.red_nether_brick_slab": "Қызыл Незер кірпіш тақтасы",
  "block.minecraft.red_nether_brick_stairs": "Қызыл Незер кірпіш тепкішегі",
  "block.minecraft.red_nether_brick_wall": "Қызыл Незер кірпіш дуалы",
  "block.minecraft.red_nether_bricks": "Қызыл Незер кірпіші",
  "block.minecraft.red_sand": "Қызыл құм",
  "block.minecraft.red_sandstone": "Қызыл құмтас",
  "block.minecraft.red_sandstone_slab": "Қызыл құмтас тақта",
  "block.minecraft.red_sandstone_stairs": "Қызыл құмтас тепкішек",
  "block.minecraft.red_sandstone_wall": "Қызыл құмтас дуал",
  "block.minecraft.red_shulker_box": "Қызыл шалкер жәшігі",
  "block.minecraft.red_stained_glass": "Қызыл шыны",
  "block.minecraft.red_stained_glass_pane": "Қызыл әйнек",
  "block.minecraft.red_terracotta": "Қызыл қыш",
  "block.minecraft.red_tulip": "Қырғалдақ",
  "block.minecraft.red_wool": "Қызыл жүн",
  "block.minecraft.redstone_block": "Редстоун блок",
  "block.minecraft.redstone_lamp": "Редстоун шам",
  "block.minecraft.redstone_ore": "Редстоун кені",
  "block.minecraft.redstone_torch": "Редстоун шырақ",
  "block.minecraft.redstone_wall_torch": "Дуалдағы редстоун шырақ",
  "block.minecraft.redstone_wire": "Редстоун сым",
  "block.minecraft.reinforced_deepslate": "Берік қатпартас",
  "block.minecraft.repeater": "Редстоун қайталағыш",
  "block.minecraft.repeating_command_block": "Қайталағыш пәрмен блогі",
  "block.minecraft.resin_block": "Шайыр блок",
  "block.minecraft.resin_brick_slab": "Шайыр кірпіш тақта",
  "block.minecraft.resin_brick_stairs": "Шайыр кірпіш тепкішек",
  "block.minecraft.resin_brick_wall": "Шайыр кірпіш дуал",
  "block.minecraft.resin_bricks": "Шайыр кірпіш",
  "block.minecraft.resin_clump": "Ұйысқан шайыр",
  "block.minecraft.respawn_anchor": "Тірілу зәкірі",
  "block.minecraft.rooted_dirt": "Тамырлы топырақ",
  "block.minecraft.rose_bush": "Раушан бұтасы",
  "block.minecraft.sand": "Құм",
  "block.minecraft.sandstone": "Құмтас",
  "block.minecraft.sandstone_slab": "Құмтас тақта",
  "block.minecraft.sandstone_stairs": "Құмтас тепкішек",
  "block.minecraft.sandstone_wall": "Құмтас дуал",
  "block.minecraft.scaffolding": "Баспалдақ",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк жаюшы",
  "block.minecraft.sculk_sensor": "Сезгір скалк",
  "block.minecraft.sculk_shrieker": "Шырылдақ скалк",
  "block.minecraft.sculk_vein": "Скалк тамыры",
  "block.minecraft.sea_lantern": "Теңіз шамы",
  "block.minecraft.sea_pickle": "Теңіз қияры",
  "block.minecraft.seagrass": "Теңізшөп",
  "block.minecraft.set_spawn": "Тірілу нүктесі орнатылды",
  "block.minecraft.short_dry_grass": "Қысқа қу шөп",
  "block.minecraft.short_grass": "Қысқа шөп",
  "block.minecraft.shroomlight": "Жарыққұлақ",
  "block.minecraft.shulker_box": "Шалкер жәшігі",
  "block.minecraft.skeleton_skull": "Бас сүйек",
  "block.minecraft.skeleton_wall_skull": "Дуалдағы бас сүйек",
  "block.minecraft.slime_block": "Шырыш блок",
  "block.minecraft.small_amethyst_bud": "Кіші аметист бүршігі",
  "block.minecraft.small_dripleaf": "Кіші тамшыжапырақ",
  "block.minecraft.smithing_table": "Темірші үстелі",
  "block.minecraft.smoker": "Ыстағыш",
  "block.minecraft.smooth_basalt": "Тегіс базальт",
  "block.minecraft.smooth_quartz": "Тегіс шынытас блок",
  "block.minecraft.smooth_quartz_slab": "Тегіс шынытас тақта",
  "block.minecraft.smooth_quartz_stairs": "Тегіс шынытас тепкішек",
  "block.minecraft.smooth_red_sandstone": "Тегіс қызыл құмтас",
  "block.minecraft.smooth_red_sandstone_slab": "Тегіс қызыл құмтас тақта",
  "block.minecraft.smooth_red_sandstone_stairs": "Тегіс қызыл құмтас тепкішек",
  "block.minecraft.smooth_sandstone": "Тегіс құмтас",
  "block.minecraft.smooth_sandstone_slab": "Тегіс құмтас тақта",
  "block.minecraft.smooth_sandstone_stairs": "Тегіс құмтас тепкішек",
  "block.minecraft.smooth_stone": "Тегіс тас",
  "block.minecraft.smooth_stone_slab": "Тегіс тас тақта",
  "block.minecraft.sniffer_egg": "Тіміскі жұмыртқасы",
  "block.minecraft.snow": "Қар",
  "block.minecraft.snow_block": "Қар блок",
  "block.minecraft.soul_campfire": "Жан ошағы",
  "block.minecraft.soul_fire": "Жан оты",
  "block.minecraft.soul_lantern": "Жан шамдалы",
  "block.minecraft.soul_sand": "Жан құмы",
  "block.minecraft.soul_soil": "Жан топырағы",
  "block.minecraft.soul_torch": "Жан шырағы",
  "block.minecraft.soul_wall_torch": "Дуалдағы жан шырағы",
  "block.minecraft.spawn.not_valid": "Төсек те жоқ, толы тірілу зәкірі де жоқ, я қолжетімсіз",
  "block.minecraft.spawner": "Құбыжық жаратқыш",
  "block.minecraft.spawner.desc1": "Тұқыммен әрекеттесу:",
  "block.minecraft.spawner.desc2": "Моб түрін орнатады",
  "block.minecraft.sponge": "Ысқыш",
  "block.minecraft.spore_blossom": "Спора гүлі",
  "block.minecraft.spruce_button": "Шырша түйме",
  "block.minecraft.spruce_door": "Шырша есік",
  "block.minecraft.spruce_fence": "Шырша шарбақ",
  "block.minecraft.spruce_fence_gate": "Шырша қақпа",
  "block.minecraft.spruce_hanging_sign": "Аспалы шырша маңдайша",
  "block.minecraft.spruce_leaves": "Шырша жапырағы",
  "block.minecraft.spruce_log": "Шырша діңгегі",
  "block.minecraft.spruce_planks": "Шырша тақтай",
  "block.minecraft.spruce_pressure_plate": "Шырша басқыш",
  "block.minecraft.spruce_sapling": "Шырша көшеті",
  "block.minecraft.spruce_shelf": "Шырша сөре",
  "block.minecraft.spruce_sign": "Шырша маңдайша",
  "block.minecraft.spruce_slab": "Шырша тақта",
  "block.minecraft.spruce_stairs": "Шырша тепкішек",
  "block.minecraft.spruce_trapdoor": "Шырша қақпақ",
  "block.minecraft.spruce_wall_hanging_sign": "Дуалдағы аспалы шырша маңдайша",
  "block.minecraft.spruce_wall_sign": "Дуалдағы шырша маңдайша",
  "block.minecraft.spruce_wood": "Шырша ағашы",
  "block.minecraft.sticky_piston": "Жабысқақ піспек",
  "block.minecraft.stone": "Тас",
  "block.minecraft.stone_brick_slab": "Тас кірпіш тақта",
  "block.minecraft.stone_brick_stairs": "Тас кірпіш тепкішек",
  "block.minecraft.stone_brick_wall": "Тас кірпіш дуал",
  "block.minecraft.stone_bricks": "Тас кірпіш",
  "block.minecraft.stone_button": "Тас түйме",
  "block.minecraft.stone_pressure_plate": "Тас басқыш",
  "block.minecraft.stone_slab": "Тас тақта",
  "block.minecraft.stone_stairs": "Тас тепкішек",
  "block.minecraft.stonecutter": "Таскесер",
  "block.minecraft.stripped_acacia_log": "Жонылған акация діңгегі",
  "block.minecraft.stripped_acacia_wood": "Жонылған акация ағашы",
  "block.minecraft.stripped_bamboo_block": "Жонылған бамбук блогі",
  "block.minecraft.stripped_birch_log": "Жонылған қайың діңгегі",
  "block.minecraft.stripped_birch_wood": "Жонылған қайың ағашы",
  "block.minecraft.stripped_cherry_log": "Жонылған шие діңгегі",
  "block.minecraft.stripped_cherry_wood": "Жонылған шие ағашы",
  "block.minecraft.stripped_crimson_hyphae": "Жонылған қырмызы гифа",
  "block.minecraft.stripped_crimson_stem": "Жонылған қырмызы сабақ",
  "block.minecraft.stripped_dark_oak_log": "Жонылған қара емен діңгегі",
  "block.minecraft.stripped_dark_oak_wood": "Жонылған қара емен ағашы",
  "block.minecraft.stripped_jungle_log": "Жонылған джунгли діңгегі",
  "block.minecraft.stripped_jungle_wood": "Жонылған джунгли ағашы",
  "block.minecraft.stripped_mangrove_log": "Жонылған мангр діңгегі",
  "block.minecraft.stripped_mangrove_wood": "Жонылған мангр ағашы",
  "block.minecraft.stripped_oak_log": "Жонылған емен діңгегі",
  "block.minecraft.stripped_oak_wood": "Жонылған емен ағашы",
  "block.minecraft.stripped_pale_oak_log": "Жонылған қу емен діңгегі",
  "block.minecraft.stripped_pale_oak_wood": "Жонылған қу емен ағашы",
  "block.minecraft.stripped_spruce_log": "Жонылған шырша діңгегі",
  "block.minecraft.stripped_spruce_wood": "Жонылған шырша ағашы",
  "block.minecraft.stripped_warped_hyphae": "Жонылған теріс жіпше",
  "block.minecraft.stripped_warped_stem": "Жонылған теріс сабақ",
  "block.minecraft.structure_block": "Құрылыс блогі",
  "block.minecraft.structure_void": "Бос блок",
  "block.minecraft.sugar_cane": "Қант құрағы",
  "block.minecraft.sunflower": "Күнбағыс",
  "block.minecraft.suspicious_gravel": "Оғаш қиыршықтас",
  "block.minecraft.suspicious_sand": "Оғаш құм",
  "block.minecraft.sweet_berry_bush": "Тәтті жидек бұтасы",
  "block.minecraft.tall_dry_grass": "Ұзын қу шөп",
  "block.minecraft.tall_grass": "Ұзын шөп",
  "block.minecraft.tall_seagrass": "Ұзын теңізшөп",
  "block.minecraft.target": "Нысана",
  "block.minecraft.terracotta": "Қыш",
  "block.minecraft.test_block": "Тест-блок",
  "block.minecraft.test_instance_block": "Мысал тест-блок",
  "block.minecraft.tinted_glass": "Қараңғы шыны",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "Динамит жарылуы өшірулі",
  "block.minecraft.torch": "Шырақ",
  "block.minecraft.torchflower": "Шырақгүл",
  "block.minecraft.torchflower_crop": "Шырақгүл өскіні",
  "block.minecraft.trapped_chest": "Тұзақ сандық",
  "block.minecraft.trial_spawner": "Сынақ жаратқышы",
  "block.minecraft.tripwire": "Кергі",
  "block.minecraft.tripwire_hook": "Кергі ілмегі",
  "block.minecraft.tube_coral": "Түтік маржан",
  "block.minecraft.tube_coral_block": "Түтік маржан блогі",
  "block.minecraft.tube_coral_fan": "Желпуіш түтік маржан",
  "block.minecraft.tube_coral_wall_fan": "Желпуіш түтік қабырға маржаны",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф кірпіш тақта",
  "block.minecraft.tuff_brick_stairs": "Туф кірпіш тепкішек",
  "block.minecraft.tuff_brick_wall": "Туф кірпіш дуал",
  "block.minecraft.tuff_bricks": "Туф кірпіш",
  "block.minecraft.tuff_slab": "Туф тақта",
  "block.minecraft.tuff_stairs": "Туф тепкішек",
  "block.minecraft.tuff_wall": "Туф дуал",
  "block.minecraft.turtle_egg": "Тасбақа жұмыртқасы",
  "block.minecraft.twisting_vines": "Ирек шырмауық",
  "block.minecraft.twisting_vines_plant": "Ирек сабақ",
  "block.minecraft.vault": "Қойма",
  "block.minecraft.verdant_froglight": "Зүмірет бақашам",
  "block.minecraft.vine": "Шырмауық",
  "block.minecraft.void_air": "Ғайып",
  "block.minecraft.wall_torch": "Дуалдағы шырақ",
  "block.minecraft.warped_button": "Теріс түйме",
  "block.minecraft.warped_door": "Теріс есік",
  "block.minecraft.warped_fence": "Теріс шарбақ",
  "block.minecraft.warped_fence_gate": "Теріс қақпа",
  "block.minecraft.warped_fungus": "Теріс арамқұлақ",
  "block.minecraft.warped_hanging_sign": "Аспалы теріс маңдайша",
  "block.minecraft.warped_hyphae": "Теріс жіпше",
  "block.minecraft.warped_nylium": "Теріс нилий",
  "block.minecraft.warped_planks": "Теріс тақтай",
  "block.minecraft.warped_pressure_plate": "Теріс басқыш",
  "block.minecraft.warped_roots": "Теріс тамыр",
  "block.minecraft.warped_shelf": "Теріс сөре",
  "block.minecraft.warped_sign": "Теріс маңдайша",
  "block.minecraft.warped_slab": "Теріс тақта",
  "block.minecraft.warped_stairs": "Теріс тепкішек",
  "block.minecraft.warped_stem": "Теріс сабақ",
  "block.minecraft.warped_trapdoor": "Теріс қақпақ",
  "block.minecraft.warped_wall_hanging_sign": "Дуалдағы аспалы теріс маңдайша",
  "block.minecraft.warped_wall_sign": "Дуалдағы теріс маңдайша",
  "block.minecraft.warped_wart_block": "Теріс без блогі",
  "block.minecraft.water": "Су",
  "block.minecraft.water_cauldron": "Қазандағы су",
  "block.minecraft.waxed_chiseled_copper": "Балауызды оюлы мыс",
  "block.minecraft.waxed_copper_bars": "Балауызды мыс шыбық",
  "block.minecraft.waxed_copper_block": "Балауызды мыс блок",
  "block.minecraft.waxed_copper_bulb": "Балауызды мыс шам",
  "block.minecraft.waxed_copper_chain": "Балауызды мыс шынжыр",
  "block.minecraft.waxed_copper_chest": "Балауызды мыс сандық",
  "block.minecraft.waxed_copper_door": "Балауызды мыс есік",
  "block.minecraft.waxed_copper_golem_statue": "Балауызды мыс големінің мүсіні",
  "block.minecraft.waxed_copper_grate": "Балауызды мыс тор",
  "block.minecraft.waxed_copper_lantern": "Балауызды мыс шам",
  "block.minecraft.waxed_copper_trapdoor": "Балауызды мыс қақпақ",
  "block.minecraft.waxed_cut_copper": "Балауызды қырлы мыс",
  "block.minecraft.waxed_cut_copper_slab": "Балауызды қырлы мыс тақта",
  "block.minecraft.waxed_cut_copper_stairs": "Балауызды қырлы мыс тепкішек",
  "block.minecraft.waxed_exposed_chiseled_copper": "Балауызды тозық оюлы мыс",
  "block.minecraft.waxed_exposed_copper": "Балауызды тозық мыс",
  "block.minecraft.waxed_exposed_copper_bars": "Балауызды тозық мыс шыбық",
  "block.minecraft.waxed_exposed_copper_bulb": "Балауызды тозық мыс шам",
  "block.minecraft.waxed_exposed_copper_chain": "Балауызды тозық мыс шынжыр",
  "block.minecraft.waxed_exposed_copper_chest": "Балауызды тозық мыс сандық",
  "block.minecraft.waxed_exposed_copper_door": "Балауызды тозық мыс есік",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Балауызды тозық мыс големнің мүсіні",
  "block.minecraft.waxed_exposed_copper_grate": "Балауызды тозық мыс тор",
  "block.minecraft.waxed_exposed_copper_lantern": "Балауызды тозық мыс шамдал",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Балауызды тозық мыс қақпақ",
  "block.minecraft.waxed_exposed_cut_copper": "Балауызды тозық қырлы мыс",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Балауызды тозық қырлы мыс тақта",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Балауызды тозық қырлы мыс тепкішек",
  "block.minecraft.waxed_exposed_lightning_rod": "Балауызды тозық жайтартқыш",
  "block.minecraft.waxed_lightning_rod": "Балауызды жайтартқыш",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Балауызды тотық оюлы мыс",
  "block.minecraft.waxed_oxidized_copper": "Балауызды тотық мыс",
  "block.minecraft.waxed_oxidized_copper_bars": "Балауызды тотық мыс шыбық",
  "block.minecraft.waxed_oxidized_copper_bulb": "Балауызды тотық мыс шам",
  "block.minecraft.waxed_oxidized_copper_chain": "Балауызды тотық мыс шынжыр",
  "block.minecraft.waxed_oxidized_copper_chest": "Балауызды тотық мыс сандық",
  "block.minecraft.waxed_oxidized_copper_door": "Балауызды тотық мыс есік",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Балауызды тотық мыс големнің мүсіні",
  "block.minecraft.waxed_oxidized_copper_grate": "Балауызды тотық мыс тор",
  "block.minecraft.waxed_oxidized_copper_lantern": "Балауызды тотық мыс шамдал",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Балауызды тотық мыс қақпақ",
  "block.minecraft.waxed_oxidized_cut_copper": "Балауызды тотық қырлы мыс",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Балауызды тотық қырлы мыс тақта",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Балауызды тотық қырлы мыс тепкішек",
  "block.minecraft.waxed_oxidized_lightning_rod": "Балауызды тотық жайтартқыш",
  "block.minecraft.waxed_weathered_chiseled_copper": "Балауызды көгерген оюлы мыс",
  "block.minecraft.waxed_weathered_copper": "Балауызды көгерген мыс",
  "block.minecraft.waxed_weathered_copper_bars": "Балауызды көгерген мыс шыбық",
  "block.minecraft.waxed_weathered_copper_bulb": "Балауызды көгерген мыс шам",
  "block.minecraft.waxed_weathered_copper_chain": "Балауызды көгерген мыс шынжыр",
  "block.minecraft.waxed_weathered_copper_chest": "Балауызды көгерген мыс сандық",
  "block.minecraft.waxed_weathered_copper_door": "Балауызды көгерген мыс есік",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Балауызды көгерген мыс големнің мүсіні",
  "block.minecraft.waxed_weathered_copper_grate": "Балауызды көгерген мыс тор",
  "block.minecraft.waxed_weathered_copper_lantern": "Балауызды көгерген мыс шамдал",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Балауызды көгерген мыс қақпақ",
  "block.minecraft.waxed_weathered_cut_copper": "Балауызды көгерген қырлы мыс",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Балауызды көгерген қырлы мыс тақта",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Балауызды көгерген қырлы мыс тепкішек",
  "block.minecraft.waxed_weathered_lightning_rod": "Балауызды көгерген жайтартқыш",
  "block.minecraft.weathered_chiseled_copper": "Көгерген оюлы мыс",
  "block.minecraft.weathered_copper": "Көгерген мыс",
  "block.minecraft.weathered_copper_bars": "Көгерген мыс шыбық",
  "block.minecraft.weathered_copper_bulb": "Көгерген мыс шам",
  "block.minecraft.weathered_copper_chain": "Көгерген мыс шынжыр",
  "block.minecraft.weathered_copper_chest": "Көгерген мыс сандық",
  "block.minecraft.weathered_copper_door": "Көгерген мыс есік",
  "block.minecraft.weathered_copper_golem_statue": "Көгерген мыс големнің мүсіні",
  "block.minecraft.weathered_copper_grate": "Көгерген мыс тор",
  "block.minecraft.weathered_copper_lantern": "Көгерген мыс шамдал",
  "block.minecraft.weathered_copper_trapdoor": "Көгерген мыс қақпақ",
  "block.minecraft.weathered_cut_copper": "Көгерген қырлы мыс",
  "block.minecraft.weathered_cut_copper_slab": "Көгерген қырлы мыс тақта",
  "block.minecraft.weathered_cut_copper_stairs": "Көгерген қырлы мыс тепкішек",
  "block.minecraft.weathered_lightning_rod": "Көгерген жайтартқыш",
  "block.minecraft.weeping_vines": "Жылаңқы шырмауық",
  "block.minecraft.weeping_vines_plant": "Жылаңқы сабақ",
  "block.minecraft.wet_sponge": "Ылғал ысқыш",
  "block.minecraft.wheat": "Бидай өскіні",
  "block.minecraft.white_banner": "Ақ байрақ",
  "block.minecraft.white_bed": "Ақ төсек",
  "block.minecraft.white_candle": "Ақ майшам",
  "block.minecraft.white_candle_cake": "Ақ майшамды торт",
  "block.minecraft.white_carpet": "Ақ кілем",
  "block.minecraft.white_concrete": "Ақ бетон",
  "block.minecraft.white_concrete_powder": "Ақ құрғақ бетон",
  "block.minecraft.white_glazed_terracotta": "Ақ зерлі қыш",
  "block.minecraft.white_shulker_box": "Ақ шалкер жәшігі",
  "block.minecraft.white_stained_glass": "Ақ шыны",
  "block.minecraft.white_stained_glass_pane": "Ақ әйнек",
  "block.minecraft.white_terracotta": "Ақ қыш",
  "block.minecraft.white_tulip": "Бозғалдақ",
  "block.minecraft.white_wool": "Ақ жүн",
  "block.minecraft.wildflowers": "Қыр гүлі",
  "block.minecraft.wither_rose": "Уизер раушаны",
  "block.minecraft.wither_skeleton_skull": "Уизер қаңқаның басы",
  "block.minecraft.wither_skeleton_wall_skull": "Дуалдағы уизер қаңқаның басы",
  "block.minecraft.yellow_banner": "Сары байрақ",
  "block.minecraft.yellow_bed": "Сары төсек",
  "block.minecraft.yellow_candle": "Сары майшам",
  "block.minecraft.yellow_candle_cake": "Сары майшамды торт",
  "block.minecraft.yellow_carpet": "Сары кілем",
  "block.minecraft.yellow_concrete": "Сары бетон",
  "block.minecraft.yellow_concrete_powder": "Сары құрғақ бетон",
  "block.minecraft.yellow_glazed_terracotta": "Сары зерлі қыш",
  "block.minecraft.yellow_shulker_box": "Сары шалкер жәшігі",
  "block.minecraft.yellow_stained_glass": "Сары шыны",
  "block.minecraft.yellow_stained_glass_pane": "Сары әйнек",
  "block.minecraft.yellow_terracotta": "Сары қыш",
  "block.minecraft.yellow_wool": "Сары жүн",
  "block.minecraft.zombie_head": "Зомби басы",
  "block.minecraft.zombie_wall_head": "Дуалдағы зомби басы",
  "item.minecraft.acacia_boat": "Акация қайық",
  "item.minecraft.acacia_chest_boat": "Сандықты акация қайық",
  "item.minecraft.allay_spawn_egg": "Тымпи тұқымы",
  "item.minecraft.amethyst_shard": "Аметист сынығы",
  "item.minecraft.angler_pottery_shard": "«Балықшы» құмыра сынығы",
  "item.minecraft.angler_pottery_sherd": "«Балықшы» құмыра сынығы",
  "item.minecraft.apple": "Алма",
  "item.minecraft.archer_pottery_shard": "«Мерген» құмыра сынығы",
  "item.minecraft.archer_pottery_sherd": "«Мерген» құмыра сынығы",
  "item.minecraft.armadillo_scute": "Кіреукей қалқаншасы",
  "item.minecraft.armadillo_spawn_egg": "Кіреукей тұқымы",
  "item.minecraft.armor_stand": "Сауыт ілгіш",
  "item.minecraft.arms_up_pottery_shard": "«Қол көтер» құмыра сынығы",
  "item.minecraft.arms_up_pottery_sherd": "«Қол көтер» құмыра сынығы",
  "item.minecraft.arrow": "Оқ",
  "item.minecraft.axolotl_bucket": "Шелектегі аксолотль",
  "item.minecraft.axolotl_spawn_egg": "Аксолотль тұқымы",
  "item.minecraft.baked_potato": "Піскен картоп",
  "item.minecraft.bamboo_chest_raft": "Сандықты бамбук сал",
  "item.minecraft.bamboo_raft": "Бамбук сал",
  "item.minecraft.bat_spawn_egg": "Жарқанат тұқымы",
  "item.minecraft.bee_spawn_egg": "Ара тұқымы",
  "item.minecraft.beef": "Шикі сиыр еті",
  "item.minecraft.beetroot": "Қызылша",
  "item.minecraft.beetroot_seeds": "Қызылша дәні",
  "item.minecraft.beetroot_soup": "Қызылша көжесі",
  "item.minecraft.birch_boat": "Қайың қайық",
  "item.minecraft.birch_chest_boat": "Сандықты қайың қайық",
  "item.minecraft.black_bundle": "Қара дорба",
  "item.minecraft.black_dye": "Қара бояу",
  "item.minecraft.black_harness": "Қара жүген",
  "item.minecraft.blade_pottery_shard": "«Қылыш» құмыра сынығы",
  "item.minecraft.blade_pottery_sherd": "«Қылыш» құмыра сынығы",
  "item.minecraft.blaze_powder": "Лаулақ ұнтағы",
  "item.minecraft.blaze_rod": "Лаулақ сырығы",
  "item.minecraft.blaze_spawn_egg": "Лаулақ тұқымы",
  "item.minecraft.blue_bundle": "Көк дорба",
  "item.minecraft.blue_dye": "Көк бояу",
  "item.minecraft.blue_egg": "Көк жұмыртқа",
  "item.minecraft.blue_harness": "Көк жүген",
  "item.minecraft.bogged_spawn_egg": "Малтыққан тұқымы",
  "item.minecraft.bolt_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "«Бұран» нақышы",
  "item.minecraft.bone": "Сүйек",
  "item.minecraft.bone_meal": "Сүйек ұны",
  "item.minecraft.book": "Кітап",
  "item.minecraft.bordure_indented_banner_pattern": "«Ирек әдіп» байрақ үлгісі",
  "item.minecraft.bow": "Садақ",
  "item.minecraft.bowl": "Тостаған",
  "item.minecraft.bread": "Нан",
  "item.minecraft.breeze_rod": "Уілдек сырығы",
  "item.minecraft.breeze_spawn_egg": "Уілдек тұқымы",
  "item.minecraft.brewer_pottery_shard": "«Демдеуші» құмыра сынығы",
  "item.minecraft.brewer_pottery_sherd": "«Демдеуші» құмыра сынығы",
  "item.minecraft.brewing_stand": "Демдегіш",
  "item.minecraft.brick": "Кірпіш",
  "item.minecraft.brown_bundle": "Қоңыр дорба",
  "item.minecraft.brown_dye": "Қоңыр бояу",
  "item.minecraft.brown_egg": "Қоңыр жұмыртқа",
  "item.minecraft.brown_harness": "Қоңыр жүген",
  "item.minecraft.brush": "Қылқалам",
  "item.minecraft.bucket": "Шелек",
  "item.minecraft.bundle": "Дорба",
  "item.minecraft.bundle.empty": "Бос",
  "item.minecraft.bundle.empty.description": "Ішіне алпыс төрт зат сыяды",
  "item.minecraft.bundle.full": "Толы",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "«Жалын» құмыра сынығы",
  "item.minecraft.burn_pottery_sherd": "«Жалын» құмыра сынығы",
  "item.minecraft.camel_husk_spawn_egg": "Түйе мәйітінің тұқымы",
  "item.minecraft.camel_spawn_egg": "Түйе тұқымы",
  "item.minecraft.carrot": "Сәбіз",
  "item.minecraft.carrot_on_a_stick": "Қармақтағы сәбіз",
  "item.minecraft.cat_spawn_egg": "Мысық тұқымы",
  "item.minecraft.cauldron": "Қазан",
  "item.minecraft.cave_spider_spawn_egg": "Үңгір өрмекшісінің тұқымы",
  "item.minecraft.chainmail_boots": "Аймауыт етік",
  "item.minecraft.chainmail_chestplate": "Аймауыт кеудеше",
  "item.minecraft.chainmail_helmet": "Аймауыт дулыға",
  "item.minecraft.chainmail_leggings": "Аймауыт шалбар",
  "item.minecraft.charcoal": "Ағаш көмір",
  "item.minecraft.cherry_boat": "Шие қайық",
  "item.minecraft.cherry_chest_boat": "Сандықты шие қайық",
  "item.minecraft.chest_minecart": "Сандықты арба",
  "item.minecraft.chicken": "Шикі тауық еті",
  "item.minecraft.chicken_spawn_egg": "Тауық тұқымы",
  "item.minecraft.chorus_fruit": "Хорус жемісі",
  "item.minecraft.clay_ball": "Кесек саз",
  "item.minecraft.clock": "Сағат",
  "item.minecraft.coal": "Көмір",
  "item.minecraft.coast_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.coast_armor_trim_smithing_template.new": "«Жағалау» нақышы",
  "item.minecraft.cocoa_beans": "Какао бұршағы",
  "item.minecraft.cod": "Шикі сетінек",
  "item.minecraft.cod_bucket": "Шелектегі сетінек",
  "item.minecraft.cod_spawn_egg": "Сетінек тұқымы",
  "item.minecraft.command_block_minecart": "Пәрмен блокті арба",
  "item.minecraft.compass": "Тұсбағар",
  "item.minecraft.cooked_beef": "Cтейк",
  "item.minecraft.cooked_chicken": "Піскен тауық еті",
  "item.minecraft.cooked_cod": "Піскен сетінек",
  "item.minecraft.cooked_mutton": "Піскен қой еті",
  "item.minecraft.cooked_porkchop": "Піскен шошқа еті",
  "item.minecraft.cooked_rabbit": "Піскен қоян еті",
  "item.minecraft.cooked_salmon": "Піскен албырт",
  "item.minecraft.cookie": "Піспенан",
  "item.minecraft.copper_axe": "Мыс балта",
  "item.minecraft.copper_boots": "Мыс етік",
  "item.minecraft.copper_chestplate": "Мыс кеудеше",
  "item.minecraft.copper_golem_spawn_egg": "Мыс голем тұқымы",
  "item.minecraft.copper_helmet": "Мыс дулыға",
  "item.minecraft.copper_hoe": "Мыс кетпен",
  "item.minecraft.copper_horse_armor": "Мыс атсауыт",
  "item.minecraft.copper_ingot": "Мыс құйма",
  "item.minecraft.copper_leggings": "Мыс шалбар",
  "item.minecraft.copper_nautilus_armor": "Мыс наутилус сауыты",
  "item.minecraft.copper_nugget": "Мыс кесегі",
  "item.minecraft.copper_pickaxe": "Мыс қайла",
  "item.minecraft.copper_shovel": "Мыс күрек",
  "item.minecraft.copper_spear": "Мыс найза",
  "item.minecraft.copper_sword": "Мыс қылыш",
  "item.minecraft.cow_spawn_egg": "Сиыр тұқымы",
  "item.minecraft.creaking_spawn_egg": "Қытыр тұқымы",
  "item.minecraft.creeper_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "«Крипер» байрақ үлгісі",
  "item.minecraft.creeper_spawn_egg": "Крипер тұқымы",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Ату жарағы:",
  "item.minecraft.crossbow.projectile.multiple": "Снаряд: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Снаряд: %s",
  "item.minecraft.cyan_bundle": "Көкзеңгір дорба",
  "item.minecraft.cyan_dye": "Көкзеңгір бояу",
  "item.minecraft.cyan_harness": "Көкзеңгір жүген",
  "item.minecraft.danger_pottery_shard": "«Қауіп» құмыра сынығы",
  "item.minecraft.danger_pottery_sherd": "«Қауіп» құмыра сынығы",
  "item.minecraft.dark_oak_boat": "Қара емен қайық",
  "item.minecraft.dark_oak_chest_boat": "Сандықты қара емен қайық",
  "item.minecraft.debug_stick": "Күй келтіру таяғы",
  "item.minecraft.debug_stick.empty": "%s еш сипаты жоқ",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) таңдалды",
  "item.minecraft.debug_stick.update": "\"%s\" ‐> %s",
  "item.minecraft.diamond": "Алмас",
  "item.minecraft.diamond_axe": "Алмас балта",
  "item.minecraft.diamond_boots": "Алмас етік",
  "item.minecraft.diamond_chestplate": "Алмас кеудеше",
  "item.minecraft.diamond_helmet": "Алмас дулыға",
  "item.minecraft.diamond_hoe": "Алмас кетпен",
  "item.minecraft.diamond_horse_armor": "Алмас атсауыт",
  "item.minecraft.diamond_leggings": "Алмас шалбар",
  "item.minecraft.diamond_nautilus_armor": "Алмас наутилус сауыты",
  "item.minecraft.diamond_pickaxe": "Алмас қайла",
  "item.minecraft.diamond_shovel": "Алмас күрек",
  "item.minecraft.diamond_spear": "Алмас найза",
  "item.minecraft.diamond_sword": "Алмас қылыш",
  "item.minecraft.disc_fragment_5": "Күйтабақ сынығы",
  "item.minecraft.disc_fragment_5.desc": "Күйтабақ — 5",
  "item.minecraft.dolphin_spawn_egg": "Дельфин тұқымы",
  "item.minecraft.donkey_spawn_egg": "Есек тұқымы",
  "item.minecraft.dragon_breath": "Айдаһар заһары",
  "item.minecraft.dried_kelp": "Кепкен ламинария",
  "item.minecraft.drowned_spawn_egg": "Батқан тұқымы",
  "item.minecraft.dune_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.dune_armor_trim_smithing_template.new": "«Дөң» нақышы",
  "item.minecraft.echo_shard": "Жаңғырық сынығы",
  "item.minecraft.egg": "Жұмыртқа",
  "item.minecraft.elder_guardian_spawn_egg": "Ежелгі қорғаушы тұқымы",
  "item.minecraft.elytra": "Элитра",
  "item.minecraft.emerald": "Замартас",
  "item.minecraft.enchanted_book": "Дуалы кітап",
  "item.minecraft.enchanted_golden_apple": "Дуалы алтын алма",
  "item.minecraft.end_crystal": "Енд кристалы",
  "item.minecraft.ender_dragon_spawn_egg": "Ендер айдаһар тұқымы",
  "item.minecraft.ender_eye": "Ендер көзі",
  "item.minecraft.ender_pearl": "Ендер інжуі",
  "item.minecraft.enderman_spawn_egg": "Ендермен тұқымы",
  "item.minecraft.endermite_spawn_egg": "Ендермит тұқымы",
  "item.minecraft.evoker_spawn_egg": "Жадыгөй тұқымы",
  "item.minecraft.experience_bottle": "Дуалы құты",
  "item.minecraft.explorer_pottery_shard": "«Зерттеуші» құмыра сынығы",
  "item.minecraft.explorer_pottery_sherd": "«Зерттеуші» құмыра сынығы",
  "item.minecraft.eye_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.eye_armor_trim_smithing_template.new": "«Көз» нақышы",
  "item.minecraft.feather": "Қауырсын",
  "item.minecraft.fermented_spider_eye": "Ашыған өрмекші көзі",
  "item.minecraft.field_masoned_banner_pattern": "«Кірпіш» байрақ үлгісі",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "Отшар",
  "item.minecraft.firework_rocket": "Отшашу",
  "item.minecraft.firework_rocket.flight": "Ұшу ұзақтығы:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Отшашу жұлдызы",
  "item.minecraft.firework_star.black": "Қара",
  "item.minecraft.firework_star.blue": "Көк",
  "item.minecraft.firework_star.brown": "Қоңыр",
  "item.minecraft.firework_star.custom_color": "Баптаулы",
  "item.minecraft.firework_star.cyan": "Көкзеңгір",
  "item.minecraft.firework_star.fade_to": "Сөну түсі:",
  "item.minecraft.firework_star.flicker": "Жылтыл",
  "item.minecraft.firework_star.gray": "Сұр",
  "item.minecraft.firework_star.green": "Жасыл",
  "item.minecraft.firework_star.light_blue": "Көгілдір",
  "item.minecraft.firework_star.light_gray": "Боз",
  "item.minecraft.firework_star.lime": "Көкжасыл",
  "item.minecraft.firework_star.magenta": "Қызылкүрең",
  "item.minecraft.firework_star.orange": "Сарғыш",
  "item.minecraft.firework_star.pink": "Қызғылт",
  "item.minecraft.firework_star.purple": "Күлгін",
  "item.minecraft.firework_star.red": "Қызыл",
  "item.minecraft.firework_star.shape": "Белгісіз пішін",
  "item.minecraft.firework_star.shape.burst": "Шашу",
  "item.minecraft.firework_star.shape.creeper": "Крипер пішінді",
  "item.minecraft.firework_star.shape.large_ball": "Үлкен шар",
  "item.minecraft.firework_star.shape.small_ball": "Шағын шар",
  "item.minecraft.firework_star.shape.star": "Жұлдыз пішінді",
  "item.minecraft.firework_star.trail": "Із",
  "item.minecraft.firework_star.white": "Ақ",
  "item.minecraft.firework_star.yellow": "Сары",
  "item.minecraft.fishing_rod": "Қармақ",
  "item.minecraft.flint": "Шақпақтас",
  "item.minecraft.flint_and_steel": "Шақпақ",
  "item.minecraft.flow_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.flow_armor_trim_smithing_template.new": "«Ағыс» нақышы",
  "item.minecraft.flow_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.flow_banner_pattern.desc": "Ағыс",
  "item.minecraft.flow_banner_pattern.new": "«Ағыс» байрақ үлгісі",
  "item.minecraft.flow_pottery_sherd": "«Ағыс» құмыра сынығы",
  "item.minecraft.flower_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.flower_banner_pattern.desc": "Гүл",
  "item.minecraft.flower_banner_pattern.new": "«Гүл» байрақ үлгісі",
  "item.minecraft.flower_pot": "Гүл құмырасы",
  "item.minecraft.fox_spawn_egg": "Түлкі тұқымы",
  "item.minecraft.friend_pottery_shard": "«Дос» құмыра сынығы",
  "item.minecraft.friend_pottery_sherd": "«Дос» құмыра сынығы",
  "item.minecraft.frog_spawn_egg": "Бақа тұқымы",
  "item.minecraft.furnace_minecart": "Пешті арба",
  "item.minecraft.ghast_spawn_egg": "Гәст тұқымы",
  "item.minecraft.ghast_tear": "Гәсттің көз жасы",
  "item.minecraft.glass_bottle": "Құты",
  "item.minecraft.glistering_melon_slice": "Жарқырауық қарбыз тілімі",
  "item.minecraft.globe_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "«Глобус» байрақ үлгісі",
  "item.minecraft.glow_berries": "Жарқырауық жидек",
  "item.minecraft.glow_ink_sac": "Жарқырауық сия",
  "item.minecraft.glow_item_frame": "Жарқырауық жақтау",
  "item.minecraft.glow_squid_spawn_egg": "Жарқырауық сегізаяқ тұқымы",
  "item.minecraft.glowstone_dust": "Жарықтас ұнтағы",
  "item.minecraft.goat_horn": "Керней",
  "item.minecraft.goat_spawn_egg": "Ешкі тұқымы",
  "item.minecraft.gold_ingot": "Алтын құйма",
  "item.minecraft.gold_nugget": "Алтын кесек",
  "item.minecraft.golden_apple": "Алтын алма",
  "item.minecraft.golden_axe": "Алтын балта",
  "item.minecraft.golden_boots": "Алтын етік",
  "item.minecraft.golden_carrot": "Алтын сәбіз",
  "item.minecraft.golden_chestplate": "Алтын кеудеше",
  "item.minecraft.golden_helmet": "Алтын дулыға",
  "item.minecraft.golden_hoe": "Алтын кетпен",
  "item.minecraft.golden_horse_armor": "Алтын атсауыт",
  "item.minecraft.golden_leggings": "Алтын шалбар",
  "item.minecraft.golden_nautilus_armor": "Алтын наутилус сауыты",
  "item.minecraft.golden_pickaxe": "Алтын қайла",
  "item.minecraft.golden_shovel": "Алтын күрек",
  "item.minecraft.golden_spear": "Алтын найза",
  "item.minecraft.golden_sword": "Алтын қылыш",
  "item.minecraft.gray_bundle": "Сұр дорба",
  "item.minecraft.gray_dye": "Сұр бояу",
  "item.minecraft.gray_harness": "Сұр жүген",
  "item.minecraft.green_bundle": "Жасыл дорба",
  "item.minecraft.green_dye": "Жасыл бояу",
  "item.minecraft.green_harness": "Жасыл жүген",
  "item.minecraft.guardian_spawn_egg": "Қорғаушы тұқымы",
  "item.minecraft.gunpowder": "Дәрі",
  "item.minecraft.guster_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.guster_banner_pattern.desc": "Құйын",
  "item.minecraft.guster_banner_pattern.new": "«Құйын» байрақ үлгісі",
  "item.minecraft.guster_pottery_sherd": "«Құйын» құмыра сынығы",
  "item.minecraft.happy_ghast_spawn_egg": "Бақытты гәст тұқымы",
  "item.minecraft.harness": "Жүген",
  "item.minecraft.heart_of_the_sea": "Теңіз жүрегі",
  "item.minecraft.heart_pottery_shard": "«Жүрек» құмыра сынығы",
  "item.minecraft.heart_pottery_sherd": "«Жүрек» құмыра сынығы",
  "item.minecraft.heartbreak_pottery_shard": "«Жаралы жүрек» құмыра сынығы",
  "item.minecraft.heartbreak_pottery_sherd": "«Жаралы жүрек» құмыра сынығы",
  "item.minecraft.hoglin_spawn_egg": "Хоглин тұқымы",
  "item.minecraft.honey_bottle": "Құты бал",
  "item.minecraft.honeycomb": "Кәрез",
  "item.minecraft.hopper_minecart": "Құйғышты арба",
  "item.minecraft.horse_spawn_egg": "Ат тұқымы",
  "item.minecraft.host_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.host_armor_trim_smithing_template.new": "«Көсем» нақышы",
  "item.minecraft.howl_pottery_shard": "«Ұлу» құмыра сынығы",
  "item.minecraft.howl_pottery_sherd": "«Ұлу» құмыра сынығы",
  "item.minecraft.husk_spawn_egg": "Мәйіт тұқымы",
  "item.minecraft.ink_sac": "Сия",
  "item.minecraft.iron_axe": "Темір балта",
  "item.minecraft.iron_boots": "Темір етік",
  "item.minecraft.iron_chestplate": "Темір кеудеше",
  "item.minecraft.iron_golem_spawn_egg": "Темір голем тұқымы",
  "item.minecraft.iron_helmet": "Темір дулыға",
  "item.minecraft.iron_hoe": "Темір кетпен",
  "item.minecraft.iron_horse_armor": "Темір атсауыт",
  "item.minecraft.iron_ingot": "Темір құйма",
  "item.minecraft.iron_leggings": "Темір шалбар",
  "item.minecraft.iron_nautilus_armor": "Темір наутилус сауыты",
  "item.minecraft.iron_nugget": "Темір кесек",
  "item.minecraft.iron_pickaxe": "Темір қайла",
  "item.minecraft.iron_shovel": "Темір күрек",
  "item.minecraft.iron_spear": "Темір найза",
  "item.minecraft.iron_sword": "Темір қылыш",
  "item.minecraft.item_frame": "Жақтау",
  "item.minecraft.jungle_boat": "Джунгли қайығы",
  "item.minecraft.jungle_chest_boat": "Сандықты джунгли қайығы",
  "item.minecraft.knowledge_book": "Білім кітабы",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Шелек лава",
  "item.minecraft.lead": "Бау",
  "item.minecraft.leather": "Тері",
  "item.minecraft.leather_boots": "Тері етік",
  "item.minecraft.leather_chestplate": "Тері күрте",
  "item.minecraft.leather_helmet": "Тері қалпақ",
  "item.minecraft.leather_horse_armor": "Тері атсауыт",
  "item.minecraft.leather_leggings": "Тері шалбар",
  "item.minecraft.light_blue_bundle": "Көгілдір дорба",
  "item.minecraft.light_blue_dye": "Көгілдір бояу",
  "item.minecraft.light_blue_harness": "Көгілдір жүген",
  "item.minecraft.light_gray_bundle": "Боз дорба",
  "item.minecraft.light_gray_dye": "Боз бояу",
  "item.minecraft.light_gray_harness": "Боз жүген",
  "item.minecraft.lime_bundle": "Көкжасыл дорба",
  "item.minecraft.lime_dye": "Көкжасыл бояу",
  "item.minecraft.lime_harness": "Көкжасыл жүген",
  "item.minecraft.lingering_potion": "Тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.awkward": "Шалағай тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.empty": "Жасалмас тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Отқа төздірер тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.harming": "Зарарлы тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.healing": "Шипалы тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.infested": "Жұқпалы тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.invisibility": "Көрінбестік тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.leaping": "Секіртер тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.levitation": "Самғауық тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.luck": "Сәтті тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.mundane": "Қарапайым тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.night_vision": "Түнде көру тұнба ішірткісі",
  "item.minecraft.lingering_potion.effect.oozing": "Тұтқыр тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.poison": "Улы тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.regeneration": "Сауықтырар тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.slow_falling": "Баяу түсірер тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.slowness": "Баяулатар тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.strength": "Күшейтер тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.swiftness": "Шапшаңдатар тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.thick": "Қою тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.turtle_master": "Тасбақа бегінің тұнба ішірткісі",
  "item.minecraft.lingering_potion.effect.water": "Тұнба құтыдағы су",
  "item.minecraft.lingering_potion.effect.water_breathing": "Суда дем берер тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.weakness": "Әлсіретер тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.weaving": "Өрмекті тұнба ішірткі",
  "item.minecraft.lingering_potion.effect.wind_charged": "Желді тұнба ішірткі",
  "item.minecraft.llama_spawn_egg": "Лама тұқымы",
  "item.minecraft.lodestone_compass": "Тасбағар",
  "item.minecraft.mace": "Күрзі",
  "item.minecraft.magenta_bundle": "Қызылкүрең дорба",
  "item.minecraft.magenta_dye": "Қызылүрең бояу",
  "item.minecraft.magenta_harness": "Қызылкүрең жүген",
  "item.minecraft.magma_cream": "Магма ұйындысы",
  "item.minecraft.magma_cube_spawn_egg": "Магма кубының тұқымы",
  "item.minecraft.mangrove_boat": "Мангр қайығы",
  "item.minecraft.mangrove_chest_boat": "Сандықты мангр қайығы",
  "item.minecraft.map": "Таза карта",
  "item.minecraft.melon_seeds": "Қарбыз дәні",
  "item.minecraft.melon_slice": "Қарбыз тілімі",
  "item.minecraft.milk_bucket": "Шелек сүт",
  "item.minecraft.minecart": "Арба",
  "item.minecraft.miner_pottery_shard": "«Кенші» құмыра сынығы",
  "item.minecraft.miner_pottery_sherd": "«Кенші» құмыра сынығы",
  "item.minecraft.mojang_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.mojang_banner_pattern.desc": "Бірдеңе",
  "item.minecraft.mojang_banner_pattern.new": "«Бірдеңе» байрақ үлгісі",
  "item.minecraft.mooshroom_spawn_egg": "Мушрум тұқымы",
  "item.minecraft.mourner_pottery_shard": "«Жоқтаушы» құмыра сынығы",
  "item.minecraft.mourner_pottery_sherd": "«Жоқтаушы» құмыра сынығы",
  "item.minecraft.mule_spawn_egg": "Қашыр тұқымы",
  "item.minecraft.mushroom_stew": "Саңырауқұлақ көжесі",
  "item.minecraft.music_disc_11": "Күйтабақ",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Күйтабақ",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Күйтабақ",
  "item.minecraft.music_disc_5.desc": "Самуел Оберг — 5",
  "item.minecraft.music_disc_blocks": "Күйтабақ",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Күйтабақ",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Күйтабақ",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Күйтабақ",
  "item.minecraft.music_disc_creator.desc": "Лина Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Күйтабақ",
  "item.minecraft.music_disc_creator_music_box.desc": "Лина Рейн — Creator (Музыкалық сандықша)",
  "item.minecraft.music_disc_far": "Күйтабақ",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Күйтабақ",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Күйтабақ",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Күйтабақ",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Күйтабақ",
  "item.minecraft.music_disc_otherside.desc": "Лина Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Күйтабақ",
  "item.minecraft.music_disc_pigstep.desc": "Лина Рейн — Pigstep",
  "item.minecraft.music_disc_precipice": "Күйтабақ",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Күйтабақ",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Күйтабақ",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Күйтабақ",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Күйтабақ",
  "item.minecraft.music_disc_tears.desc": "Eймос Родди — Tears",
  "item.minecraft.music_disc_wait": "Күйтабақ",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Күйтабақ",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Шикі қой еті",
  "item.minecraft.name_tag": "Таңба",
  "item.minecraft.nautilus_shell": "Наутилус бақалшағы",
  "item.minecraft.nautilus_spawn_egg": "Наутилус тұқымы",
  "item.minecraft.nether_brick": "Незер кірпіші",
  "item.minecraft.nether_star": "Незер жұлдызы",
  "item.minecraft.nether_wart": "Незер безі",
  "item.minecraft.netherite_axe": "Незерит балта",
  "item.minecraft.netherite_boots": "Незерит етік",
  "item.minecraft.netherite_chestplate": "Незерит кеудеше",
  "item.minecraft.netherite_helmet": "Незерит дулыға",
  "item.minecraft.netherite_hoe": "Незерит кетпен",
  "item.minecraft.netherite_horse_armor": "Незерит атсауыт",
  "item.minecraft.netherite_ingot": "Незерит құйма",
  "item.minecraft.netherite_leggings": "Незерит шалбар",
  "item.minecraft.netherite_nautilus_armor": "Незерит наутилус сауыты",
  "item.minecraft.netherite_pickaxe": "Незерит қайла",
  "item.minecraft.netherite_scrap": "Незерит сынығы",
  "item.minecraft.netherite_shovel": "Незерит күрек",
  "item.minecraft.netherite_spear": "Незерит найза",
  "item.minecraft.netherite_sword": "Незерит қылыш",
  "item.minecraft.netherite_upgrade_smithing_template": "Темірші үлгісі",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незеритше жаңғырту",
  "item.minecraft.oak_boat": "Емен қайық",
  "item.minecraft.oak_chest_boat": "Сандықты емен қайық",
  "item.minecraft.ocelot_spawn_egg": "Оцелот тұқымы",
  "item.minecraft.ominous_bottle": "Қатерлі құты",
  "item.minecraft.ominous_trial_key": "Қатерлі сынақ кілті",
  "item.minecraft.orange_bundle": "Сарғыш дорба",
  "item.minecraft.orange_dye": "Сарғыш бояу",
  "item.minecraft.orange_harness": "Сарғыш жүген",
  "item.minecraft.painting": "Сурет",
  "item.minecraft.pale_oak_boat": "Қу емен қайық",
  "item.minecraft.pale_oak_chest_boat": "Сандықты қу емен қайық",
  "item.minecraft.panda_spawn_egg": "Панда тұқымы",
  "item.minecraft.paper": "Қағаз",
  "item.minecraft.parched_spawn_egg": "Кебір тұқымы",
  "item.minecraft.parrot_spawn_egg": "Тоты тұқымы",
  "item.minecraft.phantom_membrane": "Фантом жарғағы",
  "item.minecraft.phantom_spawn_egg": "Фантом тұқымы",
  "item.minecraft.pig_spawn_egg": "Шошқа тұқымы",
  "item.minecraft.piglin_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.piglin_banner_pattern.desc": "Тұмсық",
  "item.minecraft.piglin_banner_pattern.new": "«Тұмсық» байрақ үлгісі",
  "item.minecraft.piglin_brute_spawn_egg": "Қатыгез пиглин тұқымы",
  "item.minecraft.piglin_spawn_egg": "Пиглин тұқымы",
  "item.minecraft.pillager_spawn_egg": "Тонаушы тұқымы",
  "item.minecraft.pink_bundle": "Қызғылт дорба",
  "item.minecraft.pink_dye": "Қызғылт бояу",
  "item.minecraft.pink_harness": "Қызғылт жүген",
  "item.minecraft.pitcher_plant": "Құмангүл",
  "item.minecraft.pitcher_pod": "Құмангүл бұршаққыны",
  "item.minecraft.plenty_pottery_shard": "«Береке» құмыра сынығы",
  "item.minecraft.plenty_pottery_sherd": "«Береке» құмыра сынығы",
  "item.minecraft.poisonous_potato": "Улы картоп",
  "item.minecraft.polar_bear_spawn_egg": "Ақ аю тұқымы",
  "item.minecraft.popped_chorus_fruit": "Піскен хорус жемісі",
  "item.minecraft.porkchop": "Шикі шошқа еті",
  "item.minecraft.potato": "Картоп",
  "item.minecraft.potion": "Ішірткі",
  "item.minecraft.potion.effect.awkward": "Шалағай ішірткі",
  "item.minecraft.potion.effect.empty": "Жасалмас ішірткі",
  "item.minecraft.potion.effect.fire_resistance": "Отқа төздірер ішірткі",
  "item.minecraft.potion.effect.harming": "Зарарлы ішірткі",
  "item.minecraft.potion.effect.healing": "Шипалы ішірткі",
  "item.minecraft.potion.effect.infested": "Жұқпалы ішірткі",
  "item.minecraft.potion.effect.invisibility": "Көрінбестік ішірткі",
  "item.minecraft.potion.effect.leaping": "Секіртер ішірткі",
  "item.minecraft.potion.effect.levitation": "Самғауық ішірткі",
  "item.minecraft.potion.effect.luck": "Сәтті ішірткі",
  "item.minecraft.potion.effect.mundane": "Қарапайым ішірткі",
  "item.minecraft.potion.effect.night_vision": "Түнде көру ішірткісі",
  "item.minecraft.potion.effect.oozing": "Тұтқыр ішірткі",
  "item.minecraft.potion.effect.poison": "Улы ішірткі",
  "item.minecraft.potion.effect.regeneration": "Сауықтырар ішірткісі",
  "item.minecraft.potion.effect.slow_falling": "Құлатпас ішірткі",
  "item.minecraft.potion.effect.slowness": "Баяулатар ішірткі",
  "item.minecraft.potion.effect.strength": "Күшейтер ішірткі",
  "item.minecraft.potion.effect.swiftness": "Шапшаңдатар ішірткі",
  "item.minecraft.potion.effect.thick": "Қою ішірткі",
  "item.minecraft.potion.effect.turtle_master": "Тасбақа бегінің ішірткісі",
  "item.minecraft.potion.effect.water": "Құты су",
  "item.minecraft.potion.effect.water_breathing": "Суда дем берер ішірткі",
  "item.minecraft.potion.effect.weakness": "Әлсіретер ішірткі",
  "item.minecraft.potion.effect.weaving": "Өрмекті ішірткі",
  "item.minecraft.potion.effect.wind_charged": "Желді ішірткі",
  "item.minecraft.pottery_shard_archer": "«Мерген» құмыра сынығы",
  "item.minecraft.pottery_shard_arms_up": "«Қол көтер» құмыра сынығы",
  "item.minecraft.pottery_shard_prize": "«Марапат» құмыра сынығы",
  "item.minecraft.pottery_shard_skull": "«Бас сүйек» құмыра сынығы",
  "item.minecraft.powder_snow_bucket": "Шелектегі күпсек қар",
  "item.minecraft.prismarine_crystals": "Призмарин кристалы",
  "item.minecraft.prismarine_shard": "Призмарин сынығы",
  "item.minecraft.prize_pottery_shard": "«Марапат» құмыра сынығы",
  "item.minecraft.prize_pottery_sherd": "«Марапат» құмыра сынығы",
  "item.minecraft.pufferfish": "Тікенқұрсақ",
  "item.minecraft.pufferfish_bucket": "Шелектегі тікенқұрсақ",
  "item.minecraft.pufferfish_spawn_egg": "Тікенқұрсақ тұқымы",
  "item.minecraft.pumpkin_pie": "Асқабақ бәліші",
  "item.minecraft.pumpkin_seeds": "Асқабақ дәні",
  "item.minecraft.purple_bundle": "Күлгін дорба",
  "item.minecraft.purple_dye": "Күлгін бояу",
  "item.minecraft.purple_harness": "Күлгін жүген",
  "item.minecraft.quartz": "Незер шынытасы",
  "item.minecraft.rabbit": "Шикі қоян еті",
  "item.minecraft.rabbit_foot": "Қоян аяғы",
  "item.minecraft.rabbit_hide": "Қоян терісі",
  "item.minecraft.rabbit_spawn_egg": "Қоян тұқымы",
  "item.minecraft.rabbit_stew": "Қоян көжесі",
  "item.minecraft.raiser_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "«Жиған» нақышы",
  "item.minecraft.ravager_spawn_egg": "Зіл тұқымы",
  "item.minecraft.raw_copper": "Шикі мыс",
  "item.minecraft.raw_gold": "Шикі алтын",
  "item.minecraft.raw_iron": "Шикі темір",
  "item.minecraft.recovery_compass": "Түсбағар",
  "item.minecraft.red_bundle": "Қызыл дорба",
  "item.minecraft.red_dye": "Қызыл бояу",
  "item.minecraft.red_harness": "Қызыл жүген",
  "item.minecraft.redstone": "Редстоун ұнтағы",
  "item.minecraft.resin_brick": "Шайыр кірпіш",
  "item.minecraft.resin_clump": "Ұйысқан шайыр",
  "item.minecraft.rib_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.rib_armor_trim_smithing_template.new": "«Қабырға» нақышы",
  "item.minecraft.rotten_flesh": "Шірік ет",
  "item.minecraft.saddle": "Ер",
  "item.minecraft.salmon": "Шикі албырт",
  "item.minecraft.salmon_bucket": "Шелектегі албырт",
  "item.minecraft.salmon_spawn_egg": "Албырт тұқымы",
  "item.minecraft.scrape_pottery_sherd": "«Сүргі» құмыра сынығы",
  "item.minecraft.scute": "Қалқанша",
  "item.minecraft.sentry_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "«Күзет» нақышы",
  "item.minecraft.shaper_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "«Мүсінші» нақышы",
  "item.minecraft.sheaf_pottery_shard": "«Байлам» құмыра сынығы",
  "item.minecraft.sheaf_pottery_sherd": "«Байлам» құмыра сынығы",
  "item.minecraft.shears": "Қайшы",
  "item.minecraft.sheep_spawn_egg": "Қой тұқымы",
  "item.minecraft.shelter_pottery_shard": "«Баспана» құмыра сынығы",
  "item.minecraft.shelter_pottery_sherd": "«Баспана» құмыра сынығы",
  "item.minecraft.shield": "Қалқан",
  "item.minecraft.shield.black": "Қара қалқан",
  "item.minecraft.shield.blue": "Көк қалқан",
  "item.minecraft.shield.brown": "Қоңыр қалқан",
  "item.minecraft.shield.cyan": "Көкзеңгір қалқан",
  "item.minecraft.shield.gray": "Сұр қалқан",
  "item.minecraft.shield.green": "Жасыл қалқан",
  "item.minecraft.shield.light_blue": "Көгілдір қалқан",
  "item.minecraft.shield.light_gray": "Боз қалқан",
  "item.minecraft.shield.lime": "Көкжасыл қалқан",
  "item.minecraft.shield.magenta": "Қызылкүрең қалқан",
  "item.minecraft.shield.orange": "Сарғыш қалқан",
  "item.minecraft.shield.pink": "Қызғылт қалқан",
  "item.minecraft.shield.purple": "Күлгін қалқан",
  "item.minecraft.shield.red": "Қызыл қалқан",
  "item.minecraft.shield.white": "Ақ қалқан",
  "item.minecraft.shield.yellow": "Сары қалқан",
  "item.minecraft.shulker_shell": "Шалкер сауыты",
  "item.minecraft.shulker_spawn_egg": "Шалкер тұқымы",
  "item.minecraft.sign": "Маңдайша",
  "item.minecraft.silence_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.silence_armor_trim_smithing_template.new": "«Тыныштық» нақышы",
  "item.minecraft.silverfish_spawn_egg": "Күмісбалық тұқымы",
  "item.minecraft.skeleton_horse_spawn_egg": "Қаңқа ат тұқымы",
  "item.minecraft.skeleton_spawn_egg": "Қаңқа тұқымы",
  "item.minecraft.skull_banner_pattern": "Байрақ үлгісі",
  "item.minecraft.skull_banner_pattern.desc": "Бас сүйек",
  "item.minecraft.skull_banner_pattern.new": "«Бас сүйек» байрақ үлгісі",
  "item.minecraft.skull_pottery_shard": "«Бас сүйек» құмыра сынығы",
  "item.minecraft.skull_pottery_sherd": "«Бас сүйек» құмыра сынығы",
  "item.minecraft.slime_ball": "Кесек шырыш",
  "item.minecraft.slime_spawn_egg": "Шырыш тұқымы",
  "item.minecraft.smithing_template": "Темірші үлгісі",
  "item.minecraft.smithing_template.applies_to": "Неге қолданылады:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Құйма не кристалл салыңыз",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Сауыт",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Сауыт паршасын сал",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Құймалар мен кристалдар",
  "item.minecraft.smithing_template.ingredients": "Материалдар:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Незерит құйма сал",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмас сауыт‐сайман",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмас сауыт, қару немесе құрал салыңыз",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незерит құйма",
  "item.minecraft.smithing_template.upgrade": "Жаңғырту: ",
  "item.minecraft.sniffer_spawn_egg": "Тіміскі тұқымы",
  "item.minecraft.snort_pottery_shard": "«Пысыл» құмыра сынығы",
  "item.minecraft.snort_pottery_sherd": "«Пысыл» құмыра сынығы",
  "item.minecraft.snout_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.snout_armor_trim_smithing_template.new": "«Тұмсық» нақышы",
  "item.minecraft.snow_golem_spawn_egg": "Қар голем тұқымы",
  "item.minecraft.snowball": "Кесек қар",
  "item.minecraft.spectral_arrow": "Спектрлік оқ",
  "item.minecraft.spider_eye": "Өрмекші көзі",
  "item.minecraft.spider_spawn_egg": "Өрмекші тұқымы",
  "item.minecraft.spire_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.spire_armor_trim_smithing_template.new": "«Үшкіл» нақышы",
  "item.minecraft.splash_potion": "Шашпа ішірткі",
  "item.minecraft.splash_potion.effect.awkward": "Шалағай шашпа ішірткі",
  "item.minecraft.splash_potion.effect.empty": "Жасалмас шашпа ішірткі",
  "item.minecraft.splash_potion.effect.fire_resistance": "Отқа төздірер шашпа ішірткі",
  "item.minecraft.splash_potion.effect.harming": "Зарарлы шашпа ішірткі",
  "item.minecraft.splash_potion.effect.healing": "Шипалы шашпа ішірткі",
  "item.minecraft.splash_potion.effect.infested": "Жұқпалы шашпа ішірткі",
  "item.minecraft.splash_potion.effect.invisibility": "Көрінбестік шашпа ішірткі",
  "item.minecraft.splash_potion.effect.leaping": "Секіртер шашпа ішірткі",
  "item.minecraft.splash_potion.effect.levitation": "Самғауық шашпа ішірткі",
  "item.minecraft.splash_potion.effect.luck": "Сәтті шашпа ішірткі",
  "item.minecraft.splash_potion.effect.mundane": "Қарапайым шашпа ішірткі",
  "item.minecraft.splash_potion.effect.night_vision": "Түнде көру шашпа ішірткісі",
  "item.minecraft.splash_potion.effect.oozing": "Тұтқыр шашпа ішірткі",
  "item.minecraft.splash_potion.effect.poison": "Улы шашпа ішірткі",
  "item.minecraft.splash_potion.effect.regeneration": "Сауықтырар шашпа ішірткі",
  "item.minecraft.splash_potion.effect.slow_falling": "Құлатпас шашпа ішірткі",
  "item.minecraft.splash_potion.effect.slowness": "Баяулатар шашпа ішірткі",
  "item.minecraft.splash_potion.effect.strength": "Күшейтер шашпа ішірткі",
  "item.minecraft.splash_potion.effect.swiftness": "Шапшаңдатар шашпа ішірткі",
  "item.minecraft.splash_potion.effect.thick": "Қою шашпа ішірткі",
  "item.minecraft.splash_potion.effect.turtle_master": "Тасбақа бегінің шашпа ішірткісі",
  "item.minecraft.splash_potion.effect.water": "Шашпа құтыдағы су",
  "item.minecraft.splash_potion.effect.water_breathing": "Суда дем берер шашпа ішірткі",
  "item.minecraft.splash_potion.effect.weakness": "Әлсіретер шашпа ішірткі",
  "item.minecraft.splash_potion.effect.weaving": "Өрмекті шашпа ішірткі",
  "item.minecraft.splash_potion.effect.wind_charged": "Желді шашпа ішірткі",
  "item.minecraft.spruce_boat": "Шырша қайық",
  "item.minecraft.spruce_chest_boat": "Сандықты шырша қайық",
  "item.minecraft.spyglass": "Дүрбі",
  "item.minecraft.squid_spawn_egg": "Сегізаяқ тұқымы",
  "item.minecraft.stick": "Таяқ",
  "item.minecraft.stone_axe": "Тас балта",
  "item.minecraft.stone_hoe": "Тас кетпен",
  "item.minecraft.stone_pickaxe": "Тас қайла",
  "item.minecraft.stone_shovel": "Тас күрек",
  "item.minecraft.stone_spear": "Тас найза",
  "item.minecraft.stone_sword": "Тас қылыш",
  "item.minecraft.stray_spawn_egg": "Адасқан тұқымы",
  "item.minecraft.strider_spawn_egg": "Отаяқ тұқымы",
  "item.minecraft.string": "Жіп",
  "item.minecraft.sugar": "Қант",
  "item.minecraft.suspicious_stew": "Оғаш көже",
  "item.minecraft.sweet_berries": "Тәтті жидек",
  "item.minecraft.tadpole_bucket": "Шелектегі итшабақ",
  "item.minecraft.tadpole_spawn_egg": "Итшабақ тұқымы",
  "item.minecraft.tide_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.tide_armor_trim_smithing_template.new": "«Толқын» нақышы",
  "item.minecraft.tipped_arrow": "Жебелі оқ",
  "item.minecraft.tipped_arrow.effect.awkward": "Жебелі оқ",
  "item.minecraft.tipped_arrow.effect.empty": "Жасалмас жебелі оқ",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Отқа төздірер оқ",
  "item.minecraft.tipped_arrow.effect.harming": "Зарарлы оқ",
  "item.minecraft.tipped_arrow.effect.healing": "Ем оғы",
  "item.minecraft.tipped_arrow.effect.infested": "Жұқпалану оғы",
  "item.minecraft.tipped_arrow.effect.invisibility": "Көрінбестік оқ",
  "item.minecraft.tipped_arrow.effect.leaping": "Секіртер оқ",
  "item.minecraft.tipped_arrow.effect.levitation": "Самғауық оқ",
  "item.minecraft.tipped_arrow.effect.luck": "Сәтті оқ",
  "item.minecraft.tipped_arrow.effect.mundane": "Жебелі оқ",
  "item.minecraft.tipped_arrow.effect.night_vision": "Түнде көру оғы",
  "item.minecraft.tipped_arrow.effect.oozing": "Таму оғы",
  "item.minecraft.tipped_arrow.effect.poison": "Улы оқ",
  "item.minecraft.tipped_arrow.effect.regeneration": "Айықтырар оқ",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Баяу түсірер оқ",
  "item.minecraft.tipped_arrow.effect.slowness": "Баяулатар оқ",
  "item.minecraft.tipped_arrow.effect.strength": "Күшейтер оқ",
  "item.minecraft.tipped_arrow.effect.swiftness": "Шапшаңдатар оқ",
  "item.minecraft.tipped_arrow.effect.thick": "Жебелі оқ",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Тасбақа бегінің оғы",
  "item.minecraft.tipped_arrow.effect.water": "Шашпа оқ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Суда дем алу оғы",
  "item.minecraft.tipped_arrow.effect.weakness": "Әлсіздік оғы",
  "item.minecraft.tipped_arrow.effect.weaving": "Тоқу оғы",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Желдену оғы",
  "item.minecraft.tnt_minecart": "Динамитті арба",
  "item.minecraft.torchflower_seeds": "Шырақгүл дәні",
  "item.minecraft.totem_of_undying": "Өлімсіздік тотемі",
  "item.minecraft.trader_llama_spawn_egg": "Саудагер ламасының тұқымы",
  "item.minecraft.trial_key": "Сынақ кілті",
  "item.minecraft.trident": "Айыр",
  "item.minecraft.tropical_fish": "Тропик балығы",
  "item.minecraft.tropical_fish_bucket": "Шелектегі тропик балығы",
  "item.minecraft.tropical_fish_spawn_egg": "Тропик балығының тұқымы",
  "item.minecraft.turtle_helmet": "Тасбақа сауыты",
  "item.minecraft.turtle_scute": "Тасбақа қалқаншасы",
  "item.minecraft.turtle_spawn_egg": "Тасбақа тұқымы",
  "item.minecraft.vex_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.vex_armor_trim_smithing_template.new": "«Зиянкес» нақышы",
  "item.minecraft.vex_spawn_egg": "Зиянкес тұқымы",
  "item.minecraft.villager_spawn_egg": "Шаруа тұқымы",
  "item.minecraft.vindicator_spawn_egg": "Өшпенді тұқымы",
  "item.minecraft.wandering_trader_spawn_egg": "Кезбе саудагер тұқымы",
  "item.minecraft.ward_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.ward_armor_trim_smithing_template.new": "«Сақ» нақышы",
  "item.minecraft.warden_spawn_egg": "Сақшы тұқымы",
  "item.minecraft.warped_fungus_on_a_stick": "Қармақтағы теріс арамқұлақ",
  "item.minecraft.water_bucket": "Шелек су",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "«Жөнсілтер» нақышы",
  "item.minecraft.wheat": "Бидай",
  "item.minecraft.wheat_seeds": "Бидай дәні",
  "item.minecraft.white_bundle": "Ақ дорба",
  "item.minecraft.white_dye": "Ақ бояу",
  "item.minecraft.white_harness": "Ақ жүген",
  "item.minecraft.wild_armor_trim_smithing_template": "Темірші үлгісі",
  "item.minecraft.wild_armor_trim_smithing_template.new": "«Түкпір» нақышы",
  "item.minecraft.wind_charge": "Желшар",
  "item.minecraft.witch_spawn_egg": "Мыстан тұқымы",
  "item.minecraft.wither_skeleton_spawn_egg": "Уизер қаңқа тұқымы",
  "item.minecraft.wither_spawn_egg": "Уизер тұқымы",
  "item.minecraft.wolf_armor": "Қасқыр сауыты",
  "item.minecraft.wolf_spawn_egg": "Қасқыр тұқымы",
  "item.minecraft.wooden_axe": "Ағаш балта",
  "item.minecraft.wooden_hoe": "Ағаш кетпен",
  "item.minecraft.wooden_pickaxe": "Ағаш қайла",
  "item.minecraft.wooden_shovel": "Ағаш күрек",
  "item.minecraft.wooden_spear": "Ағаш найза",
  "item.minecraft.wooden_sword": "Ағаш қылыш",
  "item.minecraft.writable_book": "Кітап пен қауырсын",
  "item.minecraft.written_book": "Аяқталған кітап",
  "item.minecraft.yellow_bundle": "Сары дорба",
  "item.minecraft.yellow_dye": "Сары бояу",
  "item.minecraft.yellow_harness": "Сары жүген",
  "item.minecraft.zoglin_spawn_egg": "Зоглин тұқымы",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби ат тұқымы",
  "item.minecraft.zombie_nautilus_spawn_egg": "Зомби наутилус тұқымы",
  "item.minecraft.zombie_spawn_egg": "Зомби тұқымы",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби шаруа тұқымы",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомби пиглин тұқымы"
}
export const kk_kz = items; 
